import React, { Component } from 'react';
import { Redirect,Link } from 'react-router-dom';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { CSVLink } from 'react-csv';
import moment from 'moment';
import 'moment-timezone';
import { format } from 'date-fns';
import Datetime from 'react-datetime';
import "react-datetime/css/react-datetime.css";
import DatePicker from "react-datepicker"; 
import "react-datepicker/dist/react-datepicker.css";
import OverlayTrigger from 'react-bootstrap/OverlayTrigger';
import Tooltip from 'react-bootstrap/Tooltip';
import {Accordion,Card,Tab,Nav} from 'react-bootstrap';
import {userGroupUrlCheck,getUserTimeZone} from '../../utils/userGroupUrlCheck';
import {URL_IMG} from '../../configs/urlConfigs';
import { ROUTE_CLIENT_EVENTS,ROUTE_AFFILIATE_EVENTS,ROUTE_CLIENT_TIMESHEET_CREW_BASED,ROUTE_AFFILIATE_TIMESHEET_CREW_BASED,ROUTE_REFRESH, ROUTE_AFFILIATE_REFRESH, PAGENUMROWS_AFFILIATE,PAGING_END_INDEX,LOGIN_AFFILIATE_GROUP, LOGIN_CLIENT_GROUP,ENUM_SHIFT_LENGTH_HHMM,SHIFT_LENGTH_MAX_HRS,AVATAR_BG_COLOR,ENUM_SCHEDULE_CREW_STATUS,SCHEDULE_CREW_STATUS} from '../../configs/staticConfigs';
import { MSG_SAVE_TIMESHEET_WITH_INVOICE_SENT,MSG_REQUIRED, MSG_NOT_FOUND,MSG_TIMESHEET_UPDATED,MSG_TIMESHEET_TOTAL_HOURS_LESS, MSG_OT_MAX_HOURS_ERROR,MSG_TIMESHEET_CSV_ERROR } from '../../configs/msgConfigs';
import { LBL_INV_NO,LBL_REJECT,LBL_VIEW_TIMESHEET,LBL_VIEW,LBL_OE_DETAILS,LBL_OT_APPROVED,LBL_INVOICE_SENT,LBL_AMOUNT,LBL_APPROVE,LBL_FILE,LBL_DESCRIPTION,LBL_GROUP_SHIFT,LBL_GROUP_CREW,LBL_GROUP_BY,LBL_APP_NAME, LBL_TIMESHEET, LBL_SELECT, LBL_LIST_ALL, LBL_ACTION_NEEDED, LBL_FILTER, LBL_DOWNLOAD,LBL_SLNUM, LBL_EVENT_TITLE, LBL_SHIFT, LBL_START_CHECKIN_TIME, LBL_END_CHECKOUT_TIME, LBL_SCHEDULED_HRS, LBL_ACTUAL_HRS, LBL_OT_HRS, LBL_APPROVAL_STATUS, LBL_CREW, LBL_CREW_NAME, LBL_CLEAR_FILTERS,LBL_AUTO, LBL_EDIT, LBL_APPROVE_TIMESHEET, LBL_EDIT_TIMESHEET, LBL_EVENT, LBL_SHIFT_AND_SKILL, LBL_PERSON, LBL_LOCATION, LBL_CHECKIN_DATE_TIME, LBL_CHECKOUT_DATE_TIME, LBL_SHIFT_LENGTH_HOURS, LBL_OVER_TIME_HOURS, LBL_CHARGE_RATE_PER_HOUR, LBL_PAY_RATE_PER_HOUR, LBL_PAY_RATE_TOTAL, LBL_CHARGE_RATE_TOTAL, LBL_OT_CHARGE_RATE_PER_HOUR, LBL_OT_PAY_RATE_PER_HOUR, LBL_OT_PAY_RATE_TOTAL, LBL_OT_CHARGE_RATE_TOTAL, LBL_CREW_PAY, LBL_MARK_ABSENT, LBL_SHIFT_TITLE,LBL_OTHER_EXPENSES,LBL_OTHER,LBL_OTHER_EXP, LBL_SKILL_PAY, LBL_CHIEF_BONUS, LBL_PAY_LEVEL, LBL_OT,LBL_TIMESHEET_OF, LBL_SHIFT_TOTAL_TRAVEL_COST, LBL_DRIVER_PAY_RATE, LBL_PASSENGER_PAY_RATE} from '../../configs/labelConfigs'; 

import {setActionNeeded,timesheetShiftListAction,timesheetDetailsAction,timesheetUpdateAction,timesheetCSVDownloadAction} from '../../actions/timesheetActions';
import * as types from '../../actions';
import {serverTimeAction,timeSheetDateHeader} from  '../../actions/commonActions';
import {otherExpListAction} from '../../actions/settings/otherExpActions';

import {formValid,decimalNumRegex,checkNumDotZero} from '../../utils/validation';
import { converDateToLocal,convertDecimalToHHMM,convertHHMMToDecimal } from '../../utils/commonUtilities';
import {checkPermissions} from '../../utils/permissions';

import ModalWindow from '../commons/helpers/modalWindow';
import Paginator from '../commons/helpers/paginator';
import Toast from '../commons/helpers/toast';
import Filter from '../commons/helpers/filterBy';
import FilterTimesheet from './filterTimesheet';
import { Alert } from 'react-bootstrap';
import {setStorage,getStorage} from '../../utils/browserStorage';
import {format as stringFormat} from 'react-string-format';
import CustomMultiSelect from '../commons/helpers/customMultiSelect';
import TimeSheetCrewBased from './timesheet_crew_based';
import { showStaffPayDetails } from '../commons/timesheetUtilities';  

import FileIcon, { defaultStyles } from 'react-file-icon';

class Timesheet extends Component {

   constructor(props){
      super();

      this.state = {
         invoiceClicked:false,
         quoteNumber:'',
         eventId:null,
         sentInvoice:false,
         enableApprove:false,
         viewHeading:false,
         otherExpenseData:{},
         selectCrewProfileId:null,
         crewBased:false,
         activePage:1,
         startIndex : 0, 
         endIndex : PAGING_END_INDEX,
         activeRowId:0,    
         perPageCount:PAGENUMROWS_AFFILIATE,
         sortField:'-created_on',
         sortOrder:'', 
         toastMessage:'',
         toastFlag:false,
         toastSuccess:true, 
         searchString:'',    
         formErrors:{            
            overTimeHours:'',
            startTime:'',
            endTime:'',
            ratePerHour:'',
            totalHours:'',
            over_time_pay_rate: '', 
            over_time_pay_total: '', 
            over_time_charge_rate: '', 
            over_time_charge_total: '',
            pay_rate: '', 
            pay_total: '', 
            charge_rate: '', 
            charge_total: '',
            otherExpCost:'',
            otherExpenseData:{},
            driver_pay_rate: '',
            passenger_pay_rate: '', 
         },          
         timesheetData:{
            event: '',
            shift:'',
            person:'',
            location:'',
            shiftLength:'00:00',
            overTimeHours:'00:00',
            startDate:'',
            endDate:'',
            startTime:'',
            endTime:'',
            ratePerHour:0,
            over_time_pay_rate: 0.00, 
            over_time_pay_total: 0.00, 
            over_time_charge_rate: 0.00, 
            over_time_charge_total: 0.00,
            pay_rate: 0.00, 
            pay_total: 0.00, 
            charge_rate: 0.00, 
            charge_total: 0.00,
            otherExpCost: 0.00,
            total_travel_cost: 0.00, 
            driver_pay_rate: 0.00,
            passenger_pay_rate: 0.00,

         },   
         timesheetShiftList:[],
         selectedTimesheetId:0,
         approvedEventStatus:0,
         actionNeeded:true,
         otLengthError: '',
         noRowsError: '',
         isFilterOn: false,
         filterClicked: 0,
         resetFilterClicked: 0,
         applyFilterClicked: 0,
         applyFilter: 0,
         filtersData: {},
         isClientPage:false,
         clientId:0,
         exportTimesheet: [],
         markAbsentChecked: false,
         crew_id: '',
         showOverTimeData: false, 
         showOtherExpenseData: false, 
         otherExpMultiListMaster:[],
         otherExpMultiListStaff:[],
         selectedOtherExpObj: [],
         defaultStartDate:'',    
         defaultEndDate:'',
         selectedStartDate: '',
         selectedEndDate: '',
      }

      this.onShowActionButtons = this.onShowActionButtons.bind(this);
      this.onHideActionButtons = this.onHideActionButtons.bind(this);
      this.modal = React.createRef();
      this.modalMarkAbsent = React.createRef();
   }

   setSelectedDate = (selectedStartDate,selectedEndDate) =>{
      this.setState({selectedStartDate,selectedEndDate})
   }

   accordionChange = (e,actionType) => {
      if(actionType==='overtime') { 
         let showVar = !this.state.showOverTimeData;
         this.setState({showOverTimeData:showVar}); 
      }
      else if(actionType==='otherexpense') { 
         let showVar = !this.state.showOtherExpenseData;
         this.setState({showOtherExpenseData:showVar}); 
      }
   }

   onDownloadTimesheet = () => {
      this.props.timesheetCSVDownloadAction({page:0,pageSize:0,sortBy:this.state.sortOrder+this.state.sortField,search:encodeURIComponent(this.state.searchString),actionNeeded:this.state.actionNeeded,applyFilter:this.state.applyFilter,filtersData:this.state.filtersData,csvDownload:1});
   }

   onResetFiltersButton = () => {   
      let resetFilterClicked = this.state.resetFilterClicked+1; 
      if(this.state.applyFilter > 0) {
          this.setState({selectedStartDate:this.state.defaultStartDate,
            selectedEndDate:this.state.defaultEndDate,resetFilterClicked,applyFilter:0,activePage:1, sortOrder:'', sortField:'-created_on', searchQuote:''}, () => {
            this.props.timesheetShiftListAction({pageSize:this.state.perPageCount,page:this.state.activePage,sortBy:this.state.sortOrder+this.state.sortField,search:encodeURIComponent(this.state.searchString),actionNeeded:this.state.actionNeeded,crew_id:this.state.crew_id});
              
              if(this.state.isFilterOn) {
                  document.getElementById("filterIcon").classList.add('active');   
              }
              else if(!this.state.isFilterOn) {
                  document.getElementById("filterIcon").classList.remove('active');   
              }
          });
      }
      else {
          this.setState({resetFilterClicked,applyFilter:0,
          selectedStartDate:this.state.defaultStartDate,
            selectedEndDate:this.state.defaultEndDate}); 
      }
   }

   onApplyFilterButton = () => {
      let applyFilterClicked = this.state.applyFilterClicked+1; 
      this.setState({applyFilterClicked}); 
   }

   applyFilters = (filtersData) => {
      // RESET ALL LISTING VALUES TO DEFAULT AND ADD FILTER FLAG AND FILTER DATA 
      let applyFilter = 0; 
      if(filtersData.filtersSelected > 0) applyFilter = 1; 
      let sortOrder = ''; 
      let sortField = '-created_on'; 
      // if(filtersData.selectedStartDate!==0) sortField = '-start_date'; 
      this.setState({activePage:1, sortOrder:sortOrder, sortField:sortField, applyFilter:applyFilter, filtersData:filtersData}, () => { 
         this.props.timesheetShiftListAction({pageSize:this.state.perPageCount,page:this.state.activePage,sortBy:this.state.sortOrder+this.state.sortField,search:encodeURIComponent(this.state.searchString),actionNeeded:this.state.actionNeeded,applyFilter:applyFilter,filtersData:filtersData,crew_id:this.state.crew_id}); 
      }); 
  }

   onShowFilterBy = () => {
      let filterClicked = (this.state.filterClicked+1);
      this.setState(prevState => ({ isFilterOn: !prevState.isFilterOn, filterClicked:filterClicked }));
      document.getElementById("filterByMenu").classList.toggle('active');
      document.getElementById("filterIcon").classList.toggle('active');
   }

   onShowActionButtons = (event, rowId) =>{
      let dropdown     = document.getElementById('dropdown-'+rowId);
      let dropdownMenu = document.getElementById('dropdown-menu-'+rowId);
      dropdown.classList.toggle('show');
      dropdownMenu.classList.toggle('show');      

      if(this.state.activeRowId===0){   
         this.setState({activeRowId:rowId}); 
         document.getElementById('img-action-'+rowId).focus();
      }else if(this.state.activeRowId===rowId){ 
         this.setState({activeRowId:0}); 
      }else if(this.state.activeRowId!==rowId){   
         dropdown     = document.getElementById('dropdown-'+this.state.activeRowId);
         dropdownMenu = document.getElementById('dropdown-menu-'+this.state.activeRowId);
         dropdown.classList.toggle('show');
         dropdownMenu.classList.toggle('show');
         this.setState({activeRowId:rowId}); 
         document.getElementById('img-action-'+rowId).focus();
      } 
   }    

   onHideActionButtons = (event, rowId) =>{
      let dropdown     = document.getElementById('dropdown-'+rowId);
      let dropdownMenu = document.getElementById('dropdown-menu-'+rowId);
      dropdown.classList.remove('show');
      dropdownMenu.classList.remove('show');
      this.setState({activeRowId:0});
   }  

   openConfirmModal = (timesheetId) => {
      if(this.state.markAbsentChecked){
         this.modalMarkAbsent.current.handleOpenModal();
      }else{
         this.onSaveFormData(timesheetId);
      }
   }

   onSaveFormData = (timesheetId) =>{
      let timeZone = getUserTimeZone(this.props.location);
      let timeZoneOffSet = timeZone.utc_offset; 
      let {formErrors} = this.state;
      const {timesheetData, approvedEventStatus} = this.state;
      let error = false;
      for(let j in formErrors.otherExpenseData){
         if(formErrors.otherExpenseData[j]){
            error = true;
            break;
         }
      }

      if(formValid(this.state) && !error){  
         let overTimeHours = convertHHMMToDecimal(timesheetData.overTimeHours); 

        if(timesheetData.overTimeHours.trim()==='' || !overTimeHours){
            formErrors.overTimeHours = MSG_REQUIRED;
        } 
        else if(parseFloat(timesheetData.overTimeHours) > parseFloat(SHIFT_LENGTH_MAX_HRS)) {
            formErrors.overTimeHours = MSG_REQUIRED;
            this.setState({formErrors,otLengthError:MSG_OT_MAX_HOURS_ERROR});
        } 
        else if(timesheetData.total_travel_cost < (timesheetData.driver_pay_rate+timesheetData.passenger_pay_rate)) {
            formErrors.driver_pay_rate = MSG_REQUIRED;
            formErrors.passenger_pay_rate = MSG_REQUIRED;
            this.setState({formErrors});
        }
        else {
            let fromMomentObj = moment(timesheetData.startDate + timesheetData.startTime, 'YYYY-MM-DDLT');
            let toMomentObj = moment(timesheetData.endDate + timesheetData.endTime, 'YYYY-MM-DDLT');
            let fromTime = '';
            let toTime = '';

            if(fromMomentObj.isValid()){
               fromTime = fromMomentObj.format('YYYY-MM-DDTHH:mm:ss')+timeZoneOffSet;
            }else{           
               let fromFormat = moment(timesheetData.startDate).format('YYYY-MM-DD');
               let fromMomentObj = moment(fromFormat + timesheetData.startTime, 'YYYY-MM-DDLT');
               fromTime = fromMomentObj.format('YYYY-MM-DDTHH:mm:ss')+timeZoneOffSet;
            }

            if(toMomentObj.isValid()){
               toTime  = toMomentObj.format('YYYY-MM-DDTHH:mm:ss')+timeZoneOffSet;         
            }else{
               let toFormat = moment(timesheetData.endDate).format('YYYY-MM-DD');
               let toMomentObj = moment(toFormat + timesheetData.endTime, 'YYYY-MM-DDLT');
               toTime = toMomentObj.format('YYYY-MM-DDTHH:mm:ss')+timeZoneOffSet;
            }  

            // OTHER EXPENSE DATA 
            // let otherExpData = this.state.selectedOtherExpObj; 
            let otherExpData = this.state.otherExpenseData; 
            let expensesObj = []; 
            let otherExpObj = {}; 
             Object.keys(otherExpData).map((staffItem,index) => {
               if(staffItem !== LBL_OTHER){
                  staffItem = Number(staffItem);
               }
               if(otherExpData[staffItem].amount && Number(otherExpData[staffItem].amount) > 0) { 
                  otherExpObj = {}; 
                  if(staffItem===LBL_OTHER) { // OTHER 
                     otherExpObj = {
                        "id": otherExpData[staffItem].masterId,
                        "expense": null, 
                        "other": LBL_OTHER,
                        "amount": otherExpData[staffItem].amount,
                        "description": otherExpData[staffItem].desc,
                        "approved": otherExpData[staffItem].approve,
                     }; 
                  }
                  else {
                     otherExpObj = {
                        "id": otherExpData[staffItem].masterId,
                        "expense": {
                           "id": staffItem,
                           "name": ""
                        }, 
                        "other": null, 
                        "amount": otherExpData[staffItem].amount,
                        "description": otherExpData[staffItem].desc,
                        "approved": otherExpData[staffItem].approve,
                     }; 
                  }
                  expensesObj.push(otherExpObj); 
               }
            })
            
            let data= {
               over_time: overTimeHours,
               over_time_pay_rate: Number(timesheetData.over_time_pay_rate),
               pay_rate: Number(timesheetData.pay_rate),
               pay_total: Number(timesheetData.pay_total),
               over_time_charge_rate: Number(timesheetData.over_time_charge_rate),
               charge_rate: Number(timesheetData.charge_rate),
               charge_total: Number(timesheetData.charge_total),
               from_time:fromTime,
               to_time:toTime, 
               over_time_approval_status:  approvedEventStatus,
               id:timesheetId,
               absent:this.state.markAbsentChecked,
               expenses: expensesObj,
               driver_pay_rate: Number(timesheetData.driver_pay_rate),
               passenger_pay_rate: Number(timesheetData.passenger_pay_rate),
            }
            this.props.timesheetUpdateAction(data);
         }
      }else{
         if(timesheetData.overTimeHours===''){
            formErrors.overTimeHours = MSG_REQUIRED;
         } 
         if(timesheetData.over_time_pay_rate===''){
            formErrors.over_time_pay_rate = MSG_REQUIRED;
         } 
         if(timesheetData.over_time_charge_rate===''){
            formErrors.over_time_charge_rate = MSG_REQUIRED;
         }
         if(timesheetData.pay_rate===''){
            formErrors.pay_rate = MSG_REQUIRED;
         } 
         if(timesheetData.charge_rate===''){
            formErrors.charge_rate = MSG_REQUIRED;
         } 
         if(timesheetData?.total_travel_cost && timesheetData?.total_travel_cost > 0) {
            if(timesheetData.driver_pay_rate===''){
               formErrors.driver_pay_rate = MSG_REQUIRED;
            } 
            if(timesheetData.passenger_pay_rate===''){
               formErrors.passenger_pay_rate = MSG_REQUIRED;  
            } 
         } 
         this.setState({formErrors});
      }
   }    

   justClick = () => {

   }

   editBtnClick = (e,itemId,timesheetId,crew_profile_id,type,invoice_sent) =>{
      let timesheetData = this.state.timesheetData;
      let timesheet = this.state.timesheetShiftList;
      let selectedShift = {};
      let selectedCrewDet= {}; 
      this.modal.current.handleOpenModal();
      if(this.state.crew_id){
         timesheet.forEach(item => {
            if(Number(item.id) === Number(itemId)){
               selectedShift = item;
               selectedCrewDet = item;
            }
         });
      }
      else{
         timesheet.forEach(item => {
            if(Number(item.id) === Number(itemId)){
               selectedShift = item;
               selectedShift.crew_details.forEach(crewDet => { 
                  if(Number(crewDet.crew_profile_id) === Number(crew_profile_id)){
                     selectedCrewDet = crewDet;
                  }
               })
               
            }
         });
      }

      console.log('selectedShift total_travel_cost: ',selectedShift.total_travel_cost);
      console.log('selectedCrewDet: ',selectedCrewDet);

      timesheetData['markAbsentStatus'] = selectedCrewDet.schedule_status == ENUM_SCHEDULE_CREW_STATUS.NOT_CHECKEDIN ? true : false;
      timesheetData['scheduleID'] = selectedShift.schedule_id;
      timesheetData['event'] = selectedShift.event_title;
      timesheetData['shift'] = selectedShift.shift_title; //+' - '+selectedShift.skill_name;
      timesheetData['location'] = selectedShift.shift_location[0].location.venue;

      
      // CONVERT DATE AND TIME TO TIMEZONE OF USER'S SETTING  
      let timeZone = getUserTimeZone(this.props.location); // TAKE TIME ZONE OF USER 
      let sDate = converDateToLocal(selectedCrewDet.checkin_datetime,timeZone.utc_offset,'yyyymmddThhmmss','-'); 
      let eDate = converDateToLocal(selectedCrewDet.checkout_datetime,timeZone.utc_offset,'yyyymmddThhmmss','-');
      let arrTime = []; 
      arrTime = sDate.split('T'); 
      let sTime = arrTime[1].substring(0,5); 
      arrTime = eDate.split('T');
      let eTime = arrTime[1].substring(0,5); 
      let overTimeHours = convertDecimalToHHMM(selectedCrewDet.over_time); 
      let scheduled_hours = convertDecimalToHHMM(selectedCrewDet.scheduled_hours); 

      timesheetData['person'] = selectedCrewDet.crew_name;
      timesheetData['shiftLength'] = scheduled_hours; 
      timesheetData['overTimeHours'] = overTimeHours; 

      if(overTimeHours === '00:00' || overTimeHours===''){
         this.setState({enableApprove:false})
      }else{
         this.setState({enableApprove:true})
      }
      timesheetData['startDate'] = sDate;
      timesheetData['endDate'] = eDate;
      timesheetData['startTime'] = sTime; 
      timesheetData['endTime'] = eTime;
      // timesheetData['ratePerHour'] = selectedCrewDet.over_time_pay_rate ? selectedCrewDet.over_time_pay_rate : 0;

      // IF OVERTIME AND OVERTIMEPAYRATE HAS VALUE BUT OVERTIMEPAYTOAL IS ZERO, THEN CALCULATE IT
      //  over_time over_time_pay_rate over_time_pay_total
      let oT = parseFloat(selectedCrewDet.over_time); 

      let oTPayRate = selectedCrewDet.over_time_pay_rate ? parseFloat(selectedCrewDet.over_time_pay_rate) : 0; 
      let oTPayTot  = selectedCrewDet.over_time_pay_total ? parseFloat(selectedCrewDet.over_time_pay_total) : 0;
      if(oT > 0 && oTPayRate > 0 && oTPayTot===0) {
         oTPayTot  = parseFloat(oT*oTPayRate).toFixed(2)
      } 

      let oTChargeRate = selectedCrewDet.over_time_charge_rate ? parseFloat(selectedCrewDet.over_time_charge_rate) : 0; 
      let oTChargeTot  = selectedCrewDet.over_time_charge_total ? parseFloat(selectedCrewDet.over_time_charge_total) : 0;
      if(oT > 0 && oTChargeRate > 0 && oTChargeTot===0) {
         oTChargeTot  = parseFloat(oT*oTChargeRate).toFixed(2)
      }

      let payRate = selectedCrewDet.pay_rate ? parseFloat(selectedCrewDet.pay_rate) : 0; 
      let payTot  = selectedCrewDet.pay_total ? parseFloat(selectedCrewDet.pay_total) : 0;

      let chargeRate = selectedCrewDet.charge_rate ? parseFloat(selectedCrewDet.charge_rate) : 0; 
      let chargeTot  = selectedCrewDet.charge_total ? parseFloat(selectedCrewDet.charge_total) : 0;

      timesheetData['over_time_pay_rate']    = parseFloat(oTPayRate).toFixed(2);
      timesheetData['over_time_charge_rate'] = parseFloat(oTChargeRate).toFixed(2);
      timesheetData['over_time_pay_total']   = parseFloat(oTPayTot).toFixed(2);
      timesheetData['over_time_charge_total']= parseFloat(oTChargeTot).toFixed(2);

      timesheetData['pay_rate']    = parseFloat(payRate).toFixed(2);
      timesheetData['charge_rate'] = parseFloat(chargeRate).toFixed(2);
      timesheetData['pay_total']   = parseFloat(payTot).toFixed(2);
      timesheetData['charge_total']= parseFloat(chargeTot).toFixed(2);

      timesheetData['total_travel_cost']     = selectedCrewDet?.total_travel_cost ? parseFloat(selectedCrewDet.total_travel_cost).toFixed(2) : 0.00;
      timesheetData['driver_pay_rate']       = selectedCrewDet?.driver_pay_rate ? parseFloat(selectedCrewDet.driver_pay_rate).toFixed(2) : 0.00;
      timesheetData['passenger_pay_rate']    = selectedCrewDet?.passenger_pay_rate ? parseFloat(selectedCrewDet.passenger_pay_rate).toFixed(2) : 0.00;

      // OTHER EXPENSES 
      let otherExpObj = []; 

      this.setState({otherExpenseData:{},viewHeading:type},()=>{
         if(selectedCrewDet.expenses && Array.isArray(selectedCrewDet.expenses) && selectedCrewDet.expenses.length) {
         otherExpObj = this.loadDataToMultiSelect(selectedCrewDet.expenses); 
         }
         else {
            otherExpObj = this.state.otherExpMultiListMaster; 
         }
         this.setState({sentInvoice:invoice_sent,selectCrewProfileId:itemId,timesheetData,selectedTimesheetId:timesheetId,approvedEventStatus:selectedCrewDet.over_time_approval_status,showOverTimeData:false,showOtherExpenseData:false,otherExpMultiListStaff:otherExpObj,selectedOtherExpObj:otherExpObj});
      });

   }   

   onStartDateChange = (date) =>{
      let {timesheetData} = this.state;
      let startDate = ''
      if(date==='' || date===null){
         startDate = format(new Date(), 'yyyy-MM-dd');
      }else{
         startDate = format(new Date(date), 'yyyy-MM-dd');
      }
      timesheetData['startDate'] = startDate;
      // timesheetData['endDate'] = startDate;
      this.setState({timesheetData});
      //Validation has been removed as per client request on 01 feb 2022
      // this.calculateMinimumHour();
   }

   onEndDateChange = (date) =>{    
      let {timesheetData} = this.state;  
      let endDate = ''
      if(date==='' || date===null){
         endDate = format(new Date(), 'yyyy-MM-dd');
      }else{
         endDate = format(new Date(date), 'yyyy-MM-dd');
      }
      timesheetData['endDate'] = endDate;
      this.setState({timesheetData}); 
      //Validation has been removed as per client request on 01 feb 2022        
      // this.calculateMinimumHour();
   }

   onShiftStartDateChange = (date) =>{
      let {filtersData} = this.state;
      let startDate = ''
      if(date==='' || date===null){
         startDate = format(new Date(), 'yyyy-MM-dd');
      }else{
         startDate = format(new Date(date), 'yyyy-MM-dd');
      }
      filtersData['shiftFromDate'] = startDate;
      filtersData['filtersSelected'] = 1;

      if(filtersData['shiftEndDate']){
         let endDate = new Date(filtersData['shiftEndDate'])
         let startDate = new Date(filtersData['shiftFromDate'])
         if(startDate > endDate){
            filtersData['shiftEndDate'] = filtersData['shiftFromDate'];
         }
         
      }
      let fromDate = filtersData['shiftFromDate']
      let endDate = filtersData['shiftEndDate']
      if(typeof endDate === 'string'){
         endDate = endDate+" 00:00:00"
      }if(typeof fromDate === 'string'){
         fromDate = fromDate+" 00:00:00"
      }

      this.setState({filtersData,selectedEndDate:new Date(endDate),selectedStartDate:new Date(fromDate)},() =>{
            if(filtersData['shiftFromDate'] && filtersData['shiftEndDate']){
               this.applyFilters(filtersData);
            }
      });
      if(filtersData['shiftFromDate'] && filtersData['shiftEndDate'] && !this.state.actionNeeded){
         let shiftEndDate_header = format(new Date(filtersData['shiftEndDate']), 'dd/MM/yyyy');
         let shiftFromDate_header = format(new Date(filtersData['shiftFromDate']), 'dd/MM/yyyy');
         this.props.timeSheetDateHeader("("+shiftFromDate_header+" - "+shiftEndDate_header+")");
      } 
   }

   onShiftEndDateChange = (date) =>{    
      let {filtersData} = this.state;  
      let endDate = ''
      if(date==='' || date===null){
         endDate = format(new Date(), 'yyyy-MM-dd');
      }else{
         endDate = format(new Date(date), 'yyyy-MM-dd');
      }
      filtersData['shiftEndDate'] = endDate;
      filtersData['filtersSelected'] = 1;

      

      this.setState({filtersData,selectedEndDate:new Date(endDate+' 00:00:00')},() =>{
         if(filtersData['shiftFromDate'] && filtersData['shiftEndDate']){
            let endDate = new Date(filtersData['shiftEndDate'])
            let startDate = new Date(filtersData['shiftFromDate'])
            if(startDate <= endDate){
               this.applyFilters(filtersData);
            }
         }
      }); 

      if(filtersData['shiftFromDate'] && filtersData['shiftEndDate'] && !this.state.actionNeeded){
         let shiftEndDate_header = format(new Date(filtersData['shiftEndDate']), 'dd/MM/yyyy');
         let shiftFromDate_header = format(new Date(filtersData['shiftFromDate']), 'dd/MM/yyyy');
         this.props.timeSheetDateHeader("("+shiftFromDate_header+" - "+shiftEndDate_header+")");
      }          
   }

   onHandleChangeStartTime = (time) =>{
      let {formErrors,timesheetData} = this.state;    
      if(time._d !== undefined){
         let startDate = format(new Date(timesheetData['startDate']), 'yyyy-MM-dd');
         timesheetData['startDate'] = startDate;
         let startTime = format(new Date(time._d), 'HH:mm');           
         timesheetData['startTime'] = startTime;
         this.setState({timesheetData,formErrors});
         //Validation has been removed as per client request on 01 feb 2022
         // this.calculateMinimumHour();
      }           
   }  

   onHandleChangeEndTime = (time) =>{
      let {formErrors,timesheetData} = this.state;    
      if(time._d !== undefined){
         let endDate = format(new Date(timesheetData['endDate']), 'yyyy-MM-dd');
         timesheetData['endDate'] = endDate;
         let endTime = format(new Date(time._d), 'HH:mm');           
         timesheetData['endTime'] = endTime;
         this.setState({timesheetData,formErrors});
         //Validation has been removed as per client request on 01 feb 2022
         // this.calculateMinimumHour();
      }           
   }  


   onBlurStartTime = (time) =>{
      let {formErrors, timesheetData} = this.state;
      if(time._d !== undefined){
         let startime = format(new Date(time._d), 'HH:mm');
         timesheetData['startTime'] = startime;
         formErrors.startTime = '';          
      }else{
         try{
               var d = new Date(),
                  s = time,
                  parts = s.match(/(\d+)\:(\d+)/),
                  hours = parseInt(parts[1], 10),
                  minutes = parseInt(parts[2], 10);

              d.setHours(hours);
              d.setMinutes(minutes);
              let startime = format(d, 'HH:mm');
              timesheetData['startTime'] = startime;
              formErrors.startTime = '';
         }catch(err) {
              formErrors.startTime = MSG_REQUIRED;                
         }          
      } 
      this.setState({timesheetData,formErrors});
   }

   onBlurEndTime = (time) =>{
      let {formErrors, timesheetData} = this.state;
      if(time._d !== undefined){
         let endTime = format(new Date(time._d), 'HH:mm');
         timesheetData['endTime'] = endTime;
         formErrors.endTime = '';          
      }else{
         try{
               var d = new Date(),
                  s = time,
                  parts = s.match(/(\d+)\:(\d+)/),
                  hours = parseInt(parts[1], 10),
                  minutes = parseInt(parts[2], 10);

              d.setHours(hours);
              d.setMinutes(minutes);
              let endTime = format(d, 'HH:mm');
              timesheetData['endTime'] = endTime;
              formErrors.endTime = '';
         }catch(err) {
              formErrors.endTime = MSG_REQUIRED;                
         }          
      } 
      this.setState({timesheetData,formErrors});
   }   

   calculateMinimumHour = ()=>{
      let {timesheetData,formErrors} = this.state;
      let totalHours = parseFloat(convertHHMMToDecimal(timesheetData.shiftLength))+parseFloat(convertHHMMToDecimal(timesheetData.overTimeHours));
      let fromMomentObj = moment(timesheetData.startDate + timesheetData.startTime, 'YYYY-MM-DDLT');
      let toMomentObj = moment(timesheetData.endDate + timesheetData.endTime, 'YYYY-MM-DDLT');

      let fromTime = '';
      let toTime = '';

      if(fromMomentObj.isValid()){
         fromTime = fromMomentObj.format('YYYY-MM-DD HH:mm:ss');
      }else{           
         let fromFormat = moment(timesheetData.startDate).format('YYYY-MM-DD');
         let fromMomentObj = moment(fromFormat + timesheetData.startTime, 'YYYY-MM-DDLT');
         fromTime = fromMomentObj.format('YYYY-MM-DD HH:mm:ss');
      }
      if(toMomentObj.isValid()){
         toTime  = toMomentObj.format('YYYY-MM-DD HH:mm:ss');         
      }else{
         let toFormat = moment(timesheetData.endDate).format('YYYY-MM-DD');
         let toMomentObj = moment(toFormat + timesheetData.endTime, 'YYYY-MM-DDLT');
         toTime = toMomentObj.format('YYYY-MM-DD HH:mm:ss');
      } 
      let diffObj    = moment.duration(moment(toTime).diff(moment(fromTime)));
      let difference = parseFloat(convertHHMMToDecimal(diffObj.asHours()+':'+Math.floor(diffObj.minutes())));
      if(difference<totalHours){
         formErrors['totalHours'] = MSG_TIMESHEET_TOTAL_HOURS_LESS;
      }else{
         formErrors['totalHours'] = '';
      }
      this.setState({formErrors});
   }

   onLoadShift = (e,eventId,crewId,isExpand)=>{
      if(!isExpand){
         this.props.timesheetDetailsAction({eventId:eventId,crewId:crewId,actionNeeded:this.state.actionNeeded});
      }else{
         let newTimesheetObj = {}
         let tempObj = this.state.timesheetShiftList;
         newTimesheetObj = tempObj.map(item => {
            if(item.crew_profile_id===crewId && item.event_id===eventId) {
               item['shift'] = [];
               item['isExpand'] = false;
            }
            return item;
         })
         this.setState({timesheetShiftList:newTimesheetObj});
      }
   }

   onShowHideDetails = (e,id)=>{
      let timesheetShiftList = this.state.timesheetShiftList; 
      let timesheet = []; 
      timesheet = timesheetShiftList.map(item => {
         if(Number(item.id)===Number(id)) {
            item['isExpand'] = !item['isExpand'];
         }
         return item;
      });
      this.setState({timesheetShiftList:timesheet}); 
   }
   
   onPagePrevious = (e) =>{
      const {
          startIndex, endIndex        
      } = this.state
      let previousPage = startIndex+1-PAGING_END_INDEX
      this.props.timesheetShiftListAction({pageSize:this.state.perPageCount,page:previousPage,sortBy:this.state.sortOrder+this.state.sortField,search:encodeURIComponent(this.state.searchString),actionNeeded:this.state.actionNeeded,applyFilter:this.state.applyFilter,filtersData:this.state.filtersData,crew_id:this.state.crew_id});
      if(startIndex===0){
          this.setState({
              activePage: previousPage,
              startIndex : startIndex,
              endIndex : endIndex
          });  
      }else{
          this.setState({
              activePage: previousPage,
              startIndex : startIndex - PAGING_END_INDEX,
              endIndex : endIndex - PAGING_END_INDEX
          });  
      }                           
   }

   onPageUp = (e) => {     

      this.props.timesheetShiftListAction({pageSize:this.state.perPageCount,page:e.target.id,sortBy:this.state.sortOrder+this.state.sortField,search:encodeURIComponent(this.state.searchString),actionNeeded:this.state.actionNeeded,applyFilter:this.state.applyFilter,filtersData:this.state.filtersData,crew_id:this.state.crew_id});

      this.setState({
          activePage: Number(e.target.id)                   
      });
   }

   onPageNext = (e) =>{   
      const {
          startIndex,endIndex            
      } = this.state     
      const {
          totalPage            
      } = this.props
             
      let nextPage = startIndex+1+PAGING_END_INDEX;
      this.props.timesheetShiftListAction({pageSize:this.state.perPageCount,page:nextPage,sortBy:this.state.sortOrder+this.state.sortField,search:encodeURIComponent(this.state.searchString),actionNeeded:this.state.actionNeeded,applyFilter:this.state.applyFilter,filtersData:this.state.filtersData,crew_id:this.state.crew_id});
      if(endIndex===totalPage || totalPage<=PAGING_END_INDEX){
          this.setState({
              activePage: nextPage,
              startIndex : startIndex,
              endIndex : endIndex
          }); 
      }else{
          this.setState({
              activePage: nextPage,
              startIndex : startIndex + PAGING_END_INDEX,
              endIndex : endIndex + PAGING_END_INDEX
          });  
      }                                   
   }

   onSort = (event,sortKey) =>{        
      let sOrder = '';
      if(this.state.sortField===sortKey){         
          sOrder = (this.state.sortOrder==='-') ? '' : '-';
          this.props.timesheetShiftListAction({pageSize:this.state.perPageCount,page:this.state.activePage,sortBy:this.state.sortOrder+this.state.sortField,search:encodeURIComponent(this.state.searchString),actionNeeded:this.state.actionNeeded,applyFilter:this.state.applyFilter,filtersData:this.state.filtersData,crew_id:this.state.crew_id});
          this.setState({ sortOrder:sOrder });            
      }else{
          this.setState({ sortField:sortKey });
          this.props.timesheetShiftListAction({pageSize:this.state.perPageCount,page:this.state.activePage,sortBy:this.state.sortOrder+this.state.sortField,search:encodeURIComponent(this.state.searchString),actionNeeded:this.state.actionNeeded,applyFilter:this.state.applyFilter,filtersData:this.state.filtersData,crew_id:this.state.crew_id});
      }        
   }

   onModalFormReset = () =>{       
      this.setState({
         timesheetId:'',
         formErrors:{
            overTimeHours:'',
            startTime:'',
            endTime:'',
            ratePerHour:'',
            totalHours:'',
            over_time_pay_rate: '',
            over_time_pay_total: '', 
            over_time_charge_rate: '', 
            over_time_charge_total: '',
            pay_rate: '',
            pay_total: '', 
            charge_rate: '', 
            charge_total: '',
            otherExpCost:'',
            otherExpenseData:{},
            driver_pay_rate: '',
            passenger_pay_rate: ''
         },
         approvedEventStatus:0,
         markAbsentChecked: false
         
      });
   }

   onCloseToast = () =>{
      this.setState({toastFlag:false,toastMessage:'',toastSuccess:false});
   } 

   applySearch = (e)=>{
      let strVal = e.target.value; 
      this.setState({searchString:strVal}, () => {  
         if(strVal.length >=3 || strVal.length===0) {
            this.props.timesheetShiftListAction({pageSize:this.state.perPageCount,page:1,sortBy:this.state.sortOrder+this.state.sortField,search:encodeURIComponent(this.state.searchString),actionNeeded:this.state.actionNeeded,applyFilter:this.state.applyFilter,filtersData:this.state.filtersData,crew_id:this.state.crew_id});
         } 
      })
   }

   setToasterState(isEnabled,message,isSucces,ms=3000){
      this.setState({toastFlag:isEnabled,toastMessage:message,toastSuccess:isSucces});
      setTimeout(()=> {
          this.onCloseToast();
      }, ms);
   }

   loadDataToMultiSelect(crewOtherExpData) {
      let masterList = [];
      let tmpList = this.state.otherExpMultiListMaster;
      let tmpObj = {}; 
      if(tmpList && Array.isArray(tmpList) && tmpList.length) {
         tmpList.forEach(item => {
            tmpObj = Object.assign({}, item); 
            masterList.push(tmpObj); 
         })
      } 
      // "expenses": [
      //     { "id":3, "expense":null, "other":"test", "amount":"15.00", "description":null },
      //     { "id":2, "other":null,  "amount":"10.00",  "description":null 
      //       "expense":
      //          { "id":24, "name":"Test Two", "short_description":"", "is_active":true, "affiliate":76 }, 
      //     }
      // ]

                     
      if(crewOtherExpData.length){ 
         let otherExpenseData = this.state.otherExpenseData;
         let newSelArr = [];
         crewOtherExpData.forEach(staffItem => {
            if(!staffItem.other || !staffItem.other.length) { // NORMAL OTHER EXPENSE ITEM FROM THE MASTER LIST 
               masterList.forEach(masterItem => {
                  if(Number(staffItem.expense.id)===Number(masterItem.value)) {
                     masterItem['masterId'] = staffItem.id ? staffItem.id : '';
                     masterItem['inputVal'] = staffItem.amount;
                     masterItem['inputValDescr'] = staffItem.description;
                     masterItem['reciepts'] = staffItem.reciepts;
                     otherExpenseData[masterItem.value] = {'select':true,
                                             'amount':Number(staffItem.amount),
                                             'desc':staffItem.description,
                                             'approve': staffItem.approved,
                                             'masterId': masterItem['masterId']
                                             

                                          }

                  }
               })
            }
            else { // OTHER 
               masterList.forEach(masterItem => {
                  if(masterItem.value===LBL_OTHER) {
                     masterItem['masterId'] = staffItem.id ? staffItem.id : '';
                     masterItem['inputVal'] = staffItem.amount;
                     masterItem['inputValDescr'] = staffItem.description;
                     masterItem['reciepts'] = staffItem.reciepts;
                     otherExpenseData[masterItem.value] = {'select':true,
                                             'amount':Number(staffItem.amount),
                                             'desc':staffItem.description,
                                             'approve': staffItem.approved,
                                             'masterId': masterItem['masterId']

                                          }

                  }
               })
            }
         });
         this.setState({otherExpenseData:otherExpenseData});
      }
      return(masterList)
   }

   formatOtherExpData(array){
      // IN OTHER EXPENSE ITEMS, IF 'Other' IS NOT THERE, ADD IT FROM FRONT-END 
      let foundOther = 0; 
      let otherExp = [];
      if(array.length>0){
          array.map(item => {
             if(item.name.trim().toLowerCase()===LBL_OTHER.trim().toLowerCase()) foundOther = 1; 
              let  expObj = {};
              expObj['masterId'] = '';
              expObj['value'] = item.id;
              expObj['label'] = item.name;
              expObj['info'] = item.short_description;
              expObj['inputVal'] = 0.00;
              expObj['inputValDescr'] = '';
              otherExp.push(expObj);
              return otherExp;
          });
      }

      //Removed Other 
      // if(foundOther===0) {
      //    let  otherObj = {};
      //    otherObj['masterId'] = '';
      //    otherObj['value'] = LBL_OTHER;
      //    otherObj['label'] = LBL_OTHER;
      //    otherObj['info'] = LBL_OTHER;
      //    otherObj['inputVal'] = 0.00;
      //    otherObj['inputValDescr'] = '';
      //    otherExp.push(otherObj);
      // } 
      return otherExp;
   }

   onOtherExpDataChange = (selectedOtherExp) =>{  
      let staffData = this.state.otherExpMultiListStaff;
      let newSelArr = []; 
      if(!selectedOtherExp.length) {   
         this.setState({selectedOtherExpObj:[]}); 
      }
      else {
         let selObj = {};
         selectedOtherExp.forEach(selItem => { 
            selObj = selItem;
            selObj.masterId = ''; 
            staffData.forEach(staffItem => {
               if(selItem.value==staffItem.value) {
                  selObj.masterId      = staffItem.masterId;
               }
            }); 
            newSelArr.push(selObj); 
         })
         this.setState({selectedOtherExpObj:newSelArr}); 
      }
   }

   otherExpenseChange = (e,id,oValue,type) =>{
      const value = e.target.type === "radio" ? type : e.target.type === "checkbox"?e.target.checked:e.target.value;

      let {otherExpenseData,formErrors} = this.state;
      let selecteObjs = this.state.selectedOtherExpObj;
      const name = e.target.name.split('_')[0];
      if(name === 'select' && value){
         let staffData = this.state.otherExpMultiListStaff;
         let newSelArr = [];
         let selObj = {};
         staffData.forEach(staffItem => {
            if(oValue==staffItem.value) {
               selObj.masterId  = staffItem.masterId;
               selObj.value = oValue;
            }
         }); 
         newSelArr.push(selObj); 
         this.setState({selectedOtherExpObj:newSelArr}); 
         if(otherExpenseData[oValue]){
            otherExpenseData[oValue][name] = value;
         }else{
            otherExpenseData[oValue] = {[name]:value};
         }
         otherExpenseData[oValue].masterId = selObj.masterId  
         otherExpenseData[oValue].approve = 1;
         formErrors.otherExpenseData[oValue] = 'input-error';

      }else if(name === 'select' && !value){
         let filteredItem = selecteObjs.filter(item => item.value !== oValue);
         this.setState({selectedOtherExpObj:filteredItem});
         for(let i in otherExpenseData){
            if(oValue === LBL_OTHER){
               if(i === oValue){
                  delete otherExpenseData[oValue];
               }
            }
            else if(parseInt(i) === oValue){
               delete otherExpenseData[oValue];
            }
         }
         formErrors.otherExpenseData[oValue] = '';
      }else{
         if(otherExpenseData[oValue]){
            if(name === 'amount') { 
               if(value.trim().length && checkNumDotZero(value.trim())) {
                  otherExpenseData[oValue][name] = value;
               }
               else {
                  otherExpenseData[oValue][name] = '';
               }
            }
            else {
               otherExpenseData[oValue][name] = value;
            }
         }else{
            if(name === 'amount') { 
               if(value.trim().length && checkNumDotZero(value.trim())) { 
                  otherExpenseData[oValue] = {[name]:value};
               }
               else {
                  otherExpenseData[oValue] = {[name]:''};
               }
            }
            else {
               otherExpenseData[oValue] = {[name]:value};
            }
         }

         if(name === 'amount'){
            if(value.trim().length === 0 || isNaN(Number(value))){
               formErrors.otherExpenseData[oValue] = 'input-error';
            }else{
               formErrors.otherExpenseData[oValue] = '';
            }
            selecteObjs.forEach(item =>{
               if(item.value === oValue){
                  if(value.trim().length && checkNumDotZero(value.trim())) {
                     item.inputVal = value;
                  }
                  else {
                     item.inputVal = '';
                  }
               }
            })
         }else if(name === 'desc'){
            selecteObjs.forEach(item =>{
               if(item.value === oValue){
                  item.inputValDescr = value
               }
            })
         }else if(name === 'approve'){
            selecteObjs.forEach(item =>{
               if(item.value === oValue){
                  item.approved = value
               }
            })
         }
         this.setState({selectedOtherExpObj:selecteObjs});
      }
      
      this.setState({otherExpenseData:otherExpenseData,formErrors:formErrors})


   }

   setStateUpdate(numRows,totalPage,activity,errorData,timesheet,timesheetDetails,timesheetCSV){
      //let {timesheetShiftList} = this.state;
      let arrResp = activity ? activity.split('~~') : []; 
      let actString = arrResp[0] ? arrResp[0] : ''; 
      
      if(actString===types.TIMESHEET_CSV_DOWNLOAD_SUCCESS){ 
         const url = window.URL.createObjectURL(new Blob([timesheetCSV]));
         const link = document.createElement('a');
         link.href = url;
         if(this.state.actionNeeded){
            link.setAttribute('download', 'timesheet-list.csv'); //or any other extension
         }else{
            let fileName = '';
            if(this.state.selectedStartDate){
               fileName = 'timesheet-list-'+format(this.state.selectedStartDate, 'dd-MM-yyyy')+'_'+format(this.state.selectedEndDate, 'dd-MM-yyyy')+'.csv';
            }else{
               fileName = 'timesheet-list-'+format(this.state.defaultStartDate, 'dd-MM-yyyy')+'_'+format(this.state.defaultEndDate, 'dd-MM-yyyy')+'.csv';
            }
            link.setAttribute('download', fileName); //or any other extension
         }
         
         document.body.appendChild(link);
         link.click();
      }
      else if(actString===types.TIMESHEET_CSV_DOWNLOAD_ERROR){ 
         this.setToasterState(true,MSG_TIMESHEET_CSV_ERROR,false);
         // timesheetCSV 
      }

      if(actString===types.TIMESHEET_SHIFT_LIST_SUCCESS){  
         timesheet = timesheet.map(item => {
            item['isExpand'] = false; // true;
            item['shift'] = item.shift_details;
            return item;
         });
         this.setState({timesheetShiftList:timesheet}, () =>{
            if(this.state.selectCrewProfileId){
               this.onShowHideDetails('',this.state.selectCrewProfileId);
            }
         })


      }else if(actString===types.TIMESHEET_DETAILS_SUCCESS){   
         let errMsg = MSG_NOT_FOUND;
         let newTimesheetObj = {}
         let tempObj = this.state.timesheetShiftList;
         newTimesheetObj = tempObj.map(item => {
            if(timesheetDetails && item.crew_profile_id===timesheetDetails[0].crew_profile_id && item.event_id===timesheetDetails[0].event_id) {
               item['shift'] = timesheetDetails;
               item['isExpand'] = false; //true;
            }
            errMsg = ''; 
            return item;
         })
         this.setState({timesheetShiftList:newTimesheetObj,noRowsError:errMsg});
      }else if(actString===types.TIMESHEET_DETAILS_ERROR){
         let errMsg = MSG_NOT_FOUND;
         this.setState({noRowsError:errMsg});
         this.setToasterState(true,JSON.stringify(errorData),false);
      }else if(actString===types.TIMESHEET_UPDATE_SUCCESS){
         if(this.state.sentInvoice){
            this.setToasterState(true,MSG_SAVE_TIMESHEET_WITH_INVOICE_SENT,true,6000);
         }else{
            this.setToasterState(true,MSG_TIMESHEET_UPDATED,true);
         }
         this.setState({sentInvoice:false});
         this.modal.current.handleModelClose(true);
         let page = this.state.activePage
         if(this.state.searchString){
            page = 1
         }       
         this.props.timesheetShiftListAction({pageSize:this.state.perPageCount,page:page,sortBy:this.state.sortOrder+this.state.sortField,search:encodeURIComponent(this.state.searchString),actionNeeded:this.state.actionNeeded,applyFilter:this.state.applyFilter,filtersData:this.state.filtersData,crew_id:this.state.crew_id});
      }else if(actString===types.TIMESHEET_UPDATE_ERROR){
         this.setToasterState(true,JSON.stringify(errorData),false);
      }    

   } 

   componentDidUpdate(prevProps) {
      const {serverTimeListActivity,isFilterOn,numRows,totalPage,activity,errorData,timesheet,timesheetDetails,timesheetCSV,otherExps,subactivity} = this.props;
      if (isFilterOn !== prevProps.isFilterOn) {
         this.inputFilter.click();   
      }else if (activity !== prevProps.activity) {
         this.setStateUpdate(numRows,totalPage,activity,errorData,timesheet,timesheetDetails,timesheetCSV);
      }

      if (subactivity !== prevProps.subactivity) {
         let arrSubResp = subactivity ? subactivity.split('~~') : []; 
         if(arrSubResp[0]===types.OTHER_EXP_LIST_SUCCESS){
            this.setState({otherExpMultiListMaster: this.formatOtherExpData(otherExps)}); 
            
         }
      }
      if(serverTimeListActivity && (serverTimeListActivity !== prevProps.serverTimeListActivity || this.state.applyFilterClicked === 0)){

         let arrTimeResp = serverTimeListActivity.split('~~');
         if(arrTimeResp[0]===types.SERVER_TIME_LIST_SUCCESS){
               // let defaultEndDate = new Date(this.props.serverTimeList.current_date+" 00:00:00");
               let defaultEndDate = new Date(this.props.serverTimeList.current_date+"T00:00:00");
               let defaultStartDate = new Date();
               defaultStartDate = new Date(defaultStartDate.setDate(defaultEndDate.getDate() - 7));
               this.setState({defaultStartDate:defaultStartDate,defaultEndDate:defaultEndDate,applyFilterClicked:1,
                  selectedStartDate:defaultStartDate,selectedEndDate:defaultEndDate})
            
         }
      } 
   }

   componentDidMount() {
        this.setState({actionNeeded:this.props.getActionNeeded});
        const { location } = this.props;
        let crew_id = '';
         if (location.pathname.split('/').length > 3){
            crew_id = location.pathname.split('/')[3];
         }
         this.setState({crew_id: crew_id});
        let userGroupData = userGroupUrlCheck(location);
        let userGroup = ''; 
        if(userGroupData!==undefined){
            userGroup = userGroupData.user_group; 
        }   
        if(userGroup===LOGIN_AFFILIATE_GROUP){
            document.body.classList.add('body-affiliate'); 
            this.setState({isClientPage:false,clientId:0});     
            this.props.otherExpListAction({page:0,column:'name',affiliateId:userGroupData.profile_id,shiftId:0});
        }else if(userGroup===LOGIN_CLIENT_GROUP){
            document.body.classList.add('body-client'); 
            this.setState({isClientPage:true, clientId:userGroupData.profile_id}); 
            this.props.otherExpListAction({page:0,column:'name',affiliateId:userGroupData.client_default_affiliate_id,shiftId:0}); 
        }
        document.title = LBL_APP_NAME+" - "+LBL_TIMESHEET;   
        if(crew_id){
            this.props.timesheetShiftListAction({crew_id: crew_id,pageSize:this.state.perPageCount,page:this.state.activePage,sortBy:this.state.sortOrder+this.state.sortField,search:encodeURIComponent(this.state.searchString),actionNeeded:this.state.actionNeeded});
        }else{
            let storeData = getStorage('timesheetvalue');
            let actionNeeded = this.props.getActionNeeded;
            let search = '';
            if(storeData && storeData != undefined){
               storeData = JSON.parse(storeData);
               if(storeData.actionNeeded === false){
                  actionNeeded = false;
               }
               search = storeData.search;
            }
            this.setState({actionNeeded:actionNeeded,searchString:search},() =>{
               this.props.timesheetShiftListAction({crew_id: crew_id,pageSize:this.state.perPageCount,page:this.state.activePage,sortBy:this.state.sortOrder+this.state.sortField,search:encodeURIComponent(search),actionNeeded:actionNeeded});
               setStorage('timesheetvalue',JSON.stringify({search:'',actionNeeded:true}));
            });
            
        }
   }  
   
   onChangeApproveOT = (e,status) =>{
      const value = status ;
      let {approvedEventStatus} = this.state;
      approvedEventStatus = value;
      this.setState({approvedEventStatus});
   }

   onTimeFilterToggle = (flag) =>{
      let {actionNeeded} = this.state;
      actionNeeded = flag;
      if(flag){
         this.props.timeSheetDateHeader('')
      }else{
         this.props.serverTimeAction(); 
         if(this.state.selectedStartDate && this.state.selectedEndDate){
            let shiftFromDate_header = format(new Date(this.state.selectedStartDate), 'dd/MM/yyyy');
            let shiftEndDate_header = format(new Date(this.state.selectedEndDate), 'dd/MM/yyyy');
            this.props.timeSheetDateHeader("("+shiftFromDate_header+" - "+shiftEndDate_header+")");
         }else{
            let shiftFromDate_header = format(new Date(this.state.defaultStartDate), 'dd/MM/yyyy');
            let shiftEndDate_header = format(new Date(this.state.defaultEndDate), 'dd/MM/yyyy');
            this.props.timeSheetDateHeader("("+shiftFromDate_header+" - "+shiftEndDate_header+")");
         }
      }
      this.setState({actionNeeded,activePage:1,searchString:''}, () => { 
         this.props.setActionNeeded(actionNeeded);
         this.props.timesheetShiftListAction({pageSize:this.state.perPageCount,page:this.state.activePage,sortBy:this.state.sortOrder+this.state.sortField,search:encodeURIComponent(this.state.searchString),actionNeeded:actionNeeded,applyFilter:this.state.applyFilter,filtersData:this.state.filtersData,crew_id:this.state.crew_id});
      });
   }

   onHandleChangeoverTimeHours = (time) =>{
      let {timesheetData,formErrors,otLengthError} = this.state;
      let enableApprove = false;
      if(time._d !== undefined){
          let overTimeHours = format(new Date(time._d), 'HH:mm');
                     
          timesheetData['overTimeHours'] = overTimeHours;
          if(overTimeHours === '00:00'){
               enableApprove = false;
          }else{
               enableApprove = true;
          }
          timesheetData['over_time_pay_total'] = (parseFloat(convertHHMMToDecimal(overTimeHours))*parseFloat(timesheetData.over_time_pay_rate)).toFixed(2);
          timesheetData['over_time_charge_total'] = (parseFloat(convertHHMMToDecimal(overTimeHours))*parseFloat(timesheetData.over_time_charge_rate)).toFixed(2);
          formErrors.overTimeHours = ''; 
          otLengthError = ''; 
      } 
      else {
         formErrors.overTimeHours = MSG_REQUIRED; 
      }
      this.setState({timesheetData,formErrors,otLengthError,enableApprove}); 
  }

   onHandleChange = (e) =>{
         const {name,value}  = e.target;   
         let {formErrors,timesheetData} = this.state;
         let valStr = value.trim(); 
         let rateVal = valStr; 
         switch(name){ 
            case 'over_time_pay_rate':
               formErrors.over_time_pay_rate = value.length <=0 || decimalNumRegex.test(value) === false
               ? MSG_REQUIRED : ""; 
               if(!valStr || valStr == '' || !checkNumDotZero(valStr)) { 
                  valStr = '';
                  rateVal = 0;  
                  timesheetData['over_time_pay_total'] = 0; 
               }
               else { 
                  timesheetData['over_time_pay_total'] = (parseFloat(convertHHMMToDecimal(timesheetData.overTimeHours))*parseFloat(rateVal)).toFixed(2);
                  
               }
               break;
            case 'over_time_charge_rate':
               formErrors.over_time_charge_rate = value.length <=0 || decimalNumRegex.test(value) === false ? MSG_REQUIRED : ""; 
               if(!valStr || valStr == '' || !checkNumDotZero(valStr)) { 
                  valStr = '';
                  rateVal = 0;
                  timesheetData['over_time_charge_total'] = 0; 
               }
               else { 
                  timesheetData['over_time_charge_total'] = (parseFloat(convertHHMMToDecimal(timesheetData.overTimeHours))*parseFloat(rateVal)).toFixed(2);
               }
               break;
            case 'pay_rate':
               formErrors.pay_rate = value.length <=0 || decimalNumRegex.test(value) === false
               ? MSG_REQUIRED : ""; 
               if(!valStr || valStr == '' || !checkNumDotZero(valStr)) { 
                  valStr = '';
                  rateVal = 0;
                  timesheetData['pay_total'] = 0; 
               }
               else { 
                  timesheetData['pay_total'] = (parseFloat(convertHHMMToDecimal(timesheetData.shiftLength))*parseFloat(rateVal)).toFixed(2);
               }
               break;
            case 'charge_rate':
               formErrors.charge_rate = value.length <=0 || decimalNumRegex.test(value) === false ? MSG_REQUIRED : ""; 
               if(!valStr || valStr == '' || !checkNumDotZero(valStr)) { 
                  valStr = '';
                  rateVal = 0;
                  timesheetData['charge_total'] = 0; 
               }
               else { 
                  timesheetData['charge_total'] = (parseFloat(convertHHMMToDecimal(timesheetData.shiftLength))*parseFloat(rateVal)).toFixed(2);
               }
               break;  
            case 'driver_pay_rate':
               formErrors.driver_pay_rate = value.length <=0 || decimalNumRegex.test(value) === false ? MSG_REQUIRED : ""; 
               if(!valStr || valStr == '' || !checkNumDotZero(valStr)) { 
                  valStr = '';
                  rateVal = 0;
                  timesheetData['driver_pay_rate'] = 0; 
               }
               else { 
                  timesheetData['driver_pay_rate'] = parseFloat(valStr);
               }
               break; 
            
            case 'passenger_pay_rate':
               formErrors.passenger_pay_rate = value.length <=0 || decimalNumRegex.test(value) === false ? MSG_REQUIRED : ""; 
               if(!valStr || valStr == '' || !checkNumDotZero(valStr)) { 
                  valStr = '';
                  rateVal = 0;
                  timesheetData['passenger_pay_rate'] = 0; 
               }
               else { 
                  timesheetData['passenger_pay_rate'] = parseFloat(valStr);
               }
               break; 

            default :
               break;
         }
         
         timesheetData[name] = valStr;

         this.setState({formErrors,timesheetData});
   }  
   

   convertMinsToHrsMins(mins) {
      let h = Math.floor(mins / 60);
      let m = mins % 60;
      h = h < 10 ? '0' + h : h;
      m = m < 10 ? '0' + m : m;
      return `${h}:${m}`;
   }

   onMarkAbsent=()=>{
      this.onSaveFormData(this.state.selectedTimesheetId);
      this.modalMarkAbsent.current.handleModelClose();
   }

   onMarkAbsentChange=(e)=>{
      const value = e.target.type === "checkbox" ? e.target.checked : e.target.value;
      this.setState({markAbsentChecked: value});
   }

   onModalAbsentReset=()=>{
      
   }

   showCrewTimesheets = (crew_id)=>{
      setStorage('timesheetvalue',JSON.stringify({search:this.state.searchString,actionNeeded:this.state.actionNeeded}));
      window.location = this.props.location.pathname + "/" + crew_id;
      
   }

   returnToTimesheets = (crew_id)=>{
      let pathname = this.props.location.pathname.split('/')
      pathname = '/' + pathname[1] + '/' + pathname[2]
      window.location = pathname;
   }
   changeCrewBasedState = () =>{
      let actionNeeded = this.state.actionNeeded;
      this.props.setActionNeeded(actionNeeded);
      this.setState({crewBased:true});
   }

   setSelectCrewProfileId = (value) =>{
      this.setState({selectCrewProfileId:value});
   }

   redirectToEvent = (e,quoteNum,eId) =>{
      let {invoiceClicked,quoteNumber,eventId} = this.state;

      quoteNumber = quoteNum;
      invoiceClicked = true;
      eventId = eId;
      this.setState({quoteNumber:quoteNumber,invoiceClicked:invoiceClicked,eventId:eventId});
   }
   
   render(){

      const {
         activePage,startIndex,endIndex,toastMessage,toastFlag,toastSuccess,timesheetData,timesheetShiftList,formErrors,selectedTimesheetId,approvedEventStatus,actionNeeded,searchString, exportTimesheet, otherExpMultiListStaff         
     } = this.state  
      const {totalPage,status } = this.props; 
      let is_active = true; 
      
      let userGroupData = userGroupUrlCheck(this.props.location);
      let userGroup = ''; 
      let profileCurrency = '';
      let supervisor = '';
      let lblCrew = 'Staff';
      // let scheduleStatus;
      if(userGroupData!==undefined){
         userGroup = userGroupData.user_group; 
         profileCurrency = userGroupData.profile_currency; 
         supervisor = userGroupData.supervisor_name; 
         is_active = userGroupData.is_active; 
         if(userGroupData.staff_name){
            lblCrew = userGroupData.staff_name; 
         }
      }
      let lblCrewName = stringFormat('{0} Name',lblCrew);
      let lblCrewPay = stringFormat('{0} Pay',lblCrew)

      if(status===401 || status===403){
         if(userGroup===LOGIN_AFFILIATE_GROUP){
            return <Redirect to={ROUTE_AFFILIATE_REFRESH} />;
         }else{
            return <Redirect to={ROUTE_REFRESH} />;
         }
      }  


      
      let isTimesheetModify = is_active===true && checkPermissions("timesheet","modify");

      let selectedStartDate = '';
      let selectedEndDate = '';
      if(timesheetData.startDate !== ''){
         if(typeof timesheetData.startDate === 'string'){

            selectedStartDate = new Date(timesheetData.startDate.split('T')[0]+" 00:00:00");           
         }else{
            selectedStartDate = new Date(timesheetData.startDate);
         }
      }
      if(timesheetData.endDate!==''){
         if(typeof timesheetData.endDate === 'string'){
            selectedEndDate = new Date(timesheetData.endDate.split('T')[0]+" 00:00:00");
         }else{
            selectedEndDate = new Date(timesheetData.endDate);
         }
      } 
      let headers = [];
      let timeZone =  getUserTimeZone(this.props.location);
      let selectedoverTimeHours = '00:00'; 
      let rowNum = 0;
      let profileImgTag = '';
      let crew_details = '';
      let crew_name = ''
      if(this.state.crew_id){
         crew_details = timesheetShiftList[0];
         if(crew_details){
            crew_name = crew_details.crew_name;
            let imageClass = crew_details.is_crew_chief?'img-fluid img-prof-small img-crew-chief':'img-fluid img-prof-small';
            profileImgTag = <img className={imageClass} src={require('../../'+URL_IMG+'crew-icon.jpg')} alt={crew_details.crew_name} title={crew_details.crew_name} />;
            if ((crew_details.crew_profile_image) && crew_details.crew_profile_image.trim().length > 0){
                profileImgTag = <img className={imageClass} src={crew_details.crew_profile_image} alt={crew_details.crew_name} title={crew_details.crew_name} />;
            }else if(((!crew_details.crew_profile_image) || crew_details.crew_profile_image.trim().length===0) && crew_details.avatar_name && crew_details.avatar_name.trim().length > 0){
              let pcolor = crew_details.profile_color ? crew_details.profile_color : AVATAR_BG_COLOR; 
            profileImgTag = <div title={crew_details.crew_name} className={crew_details.is_crew_chief?'center-align img-fluid img-prof-small img-avatar img-crew-chief':'center-align img-fluid img-prof-small img-avatar'} style={{ background:pcolor,borderColor:pcolor}}>{crew_details.avatar_name}</div>; 
            }
         }
      }
      if(this.state.crewBased === true){
         if(userGroup===LOGIN_AFFILIATE_GROUP){
            return <Redirect to={ROUTE_AFFILIATE_TIMESHEET_CREW_BASED}/>
         }else{
            return <Redirect to={ROUTE_CLIENT_TIMESHEET_CREW_BASED}/>
         }

      }
      if(this.state.invoiceClicked){
         if(userGroup===LOGIN_AFFILIATE_GROUP)
            return <Redirect to={{pathname: ROUTE_AFFILIATE_EVENTS,state:{quoteNumber:this.state.quoteNumber,eventId:this.state.eventId}}} />
         else
            return <Redirect to={{pathname: ROUTE_CLIENT_EVENTS,state:{quoteNumber:this.state.quoteNumber,eventId:this.state.eventId}}} />
      }
      return(
         <React.Fragment>
            <div className="col-md-12">
               <Toast toastDescription={toastMessage} toastFlag={toastFlag} toastSuccess={toastSuccess} closeToast={this.onCloseToast} />
               <div className="box">
                  {this.state.crew_id &&
                     <div className="box-head">
                        <Link className="back-button margin-top-6" to="#" onClick={e => this.returnToTimesheets()}><i className="las la-arrow-left"></i></Link>
                        <div className="dataTables_filter"><label>
                           <input type="search" className="" placeholder={LBL_EVENT_TITLE+'/'+LBL_SHIFT_TITLE} id="my-search-input" onChange={this.applySearch} value={searchString} /></label>
                        </div>
                        <div className="crew__aside margin-center text-no-wrap">
                           <div className="crew__thumb text-no-wrap width650">
                              {profileImgTag}  &nbsp; &nbsp; {crew_name && crew_name.length ? LBL_TIMESHEET_OF : ''} <span className="text-bold text-no-wrap">{crew_name}</span>
                           </div>
                        </div>
                     </div>
                  }
                  {!this.state.crew_id &&
                  <div className="box-head overflow-visible-imp">
                     <div className="dataTables_filter"><label>
                        <input type="search" className="" placeholder={lblCrewName+'/'+LBL_EVENT_TITLE} id="my-search-input" onChange={this.applySearch} value={searchString} /></label>
                     </div>

                     { !actionNeeded && 
                     <>
                     <div  className={this.state.applyFilter ? 'filter-btn-wrapper  text-primary-filter':'filter-btn-wrapper text-primary'}>
                        <OverlayTrigger
                            placement="top"
                            delay={{ show: 450, hide: 250 }}
                            overlay={<Tooltip id="filterIcon-tooltip" style={{
                                opacity: 0.4,
                              }}>
                            {LBL_FILTER}
                          </Tooltip>}
                        >
                            <button id="filterIcon" ref={input => this.inputFilter = input} onClick={this.onShowFilterBy} className={this.state.applyFilter ? 'filter-btn  text-primary-filter':'filter-btn text-primary'}><i className="las la-filter"></i></button>
                        </OverlayTrigger>
                     </div>
                     {this.state.applyFilter > 0 && 
                        <div className="text-12 div150" onClick={this.onResetFiltersButton} >&nbsp; &nbsp; <Link to="#" >{LBL_CLEAR_FILTERS}</Link></div>} 
                     </>}   



                     
                     <div className="btn-group btn-group-sm to-right toggle-view padding-right-15">
                          <OverlayTrigger
                              placement="top"
                              delay={{ show: 450, hide: 250 }}
                              overlay={<Tooltip id="list-tooltip" style={{
                                  opacity: 0.4,
                                }}>
                              {LBL_ACTION_NEEDED}
                          </Tooltip>}
                          > 
                              <Link className={actionNeeded?'btn btn-outline-primary active':'btn btn-outline-primary'} to="#" onClick={(e) =>this.onTimeFilterToggle(true)}>
                              <i className="las la-hand-pointer"></i> </Link>
                          </OverlayTrigger>
                          <OverlayTrigger
                              placement="top"
                              delay={{ show: 450, hide: 250 }}
                              overlay={<Tooltip id="calendar-tooltip" style={{
                                  opacity: 0.4,
                                }}>
                              {LBL_LIST_ALL} 
                          </Tooltip>}
                          >
                              <Link className={!actionNeeded?'btn btn-outline-primary active':'btn btn-outline-primary'} to="#" onClick={(e) =>this.onTimeFilterToggle(false)}>
                              <i className="las la-list-alt"></i>  </Link>
                          </OverlayTrigger>
                     </div>   
                     

                     <div className="btn-group btn-group-sm to-right export-icon filter-btn-wrapper">
                     {Array.isArray(timesheetShiftList) && timesheetShiftList.length > 0 && <OverlayTrigger
                        placement="top"
                        delay={{ show: 250, hide: 400 }}
                        overlay={<Tooltip id="download-tooltip" style={{
                           opacity: 0.4,
                        }}>
                        {LBL_DOWNLOAD}
                        </Tooltip>}
                        >
                           <Link className={'btn btn-outline-primary filter-btn'} to="#" onClick={(e) =>this.onDownloadTimesheet()}><i className="las la-file-download"></i></Link>
                        </OverlayTrigger>}                
                     </div> 
                     {exportTimesheet.length > 0 && <CSVLink className="hidden" data={exportTimesheet} headers={headers} filename= {"timesheet-list.csv"}><i className="las la-file-download"></i></CSVLink>}  
                     <div className="btn-group btn-group-sm to-right export-icon filter-btn-wrapper">
                        <OverlayTrigger
                           placement="top"
                           delay={{ show: 250, hide: 400 }}
                           overlay={<Tooltip id="download-tooltip" style={{
                              opacity: 0.4,
                           }}>
                           {LBL_GROUP_BY}
                           </Tooltip>}
                           >
                           <div className="groupBy-input">
                              <div className="form-group select-input">
                                 <select name="crewBasedOption" onChange={this.changeCrewBasedState} value={'0'} className={'groupBy'}  tabIndex="1" >
                                 <option key="0" value="0">{LBL_GROUP_SHIFT}</option>
                                 <option key="1" value="1">{stringFormat(LBL_GROUP_CREW,lblCrew)}</option>
                                 
                                 </select>
                              </div> 
                          </div> 

                           {/*<Link className="dropdown-item edit" to="#" onClick={this.changeCrewBasedState}>{stringFormat(LBL_GROUP_CREW,lblCrew)}</Link>*/} 
                           </OverlayTrigger>
                     </div>
                     {/* <div className="btn-group btn-group-sm to-right export-icon filter-btn-wrapper">
                        <OverlayTrigger  placement="top" delay={{ show: 250, hide: 400 }}
                        overlay={<Tooltip id="download-tooltip" style={{
                           opacity: 0.4,
                        }}>
                        {LBL_DOWNLOAD}
                        </Tooltip>}
                        >
                           <CSVLink className="btn btn-outline-primary filter-btn" data={exportTimesheet} headers={headers} filename= {"timesheet-list.csv"}
                        ><i className="las la-file-download"></i></CSVLink>  
                        </OverlayTrigger>                   
                     </div>  */}
                     {!actionNeeded && 
                        <div className={"to-right dateFilter"}>
                           <div className={"cal-3"}>
                                <div className="form-group">
                                    <div className={'calendar-input'}>
                                        <DatePicker 
                                            onChange={selected =>this.onShiftStartDateChange(selected)}
                                            name="startDate"
                                            showMonthDropdown
                                            showYearDropdown
                                            dropdownMode="select"
                                            dateFormat="dd/MM/yyyy"
                                            placeholderText="Shift Start Date"
                                            fixedHeight          
                                            className={formErrors.startDate ? "input-error" : ''}
                                            selected={this.state.selectedStartDate?this.state.selectedStartDate:this.state.defaultStartDate}
                                            placeHolderTextStyle={{ color: '#d3d3d3' }}

                                        />
                                    </div>
                                </div>
                            </div>
                            <div className={"cal-3"}>
                                <div className="form-group">
                                    <div className={'calendar-input'}>
                                            <DatePicker 
                                                selected={this.state.selectedEndDate?this.state.selectedEndDate:this.state.defaultEndDate}
                                                name="endDate"
                                                showMonthDropdown
                                                showYearDropdown
                                                dropdownMode="select"
                                                dateFormat="dd/MM/yyyy"
                                                placeholderText="Shift End Date"
                                                minDate={this.state.selectedStartDate}
                                                fixedHeight       
                                                onChange={selected =>this.onShiftEndDateChange(selected)}                       
                                            />
                                    </div>
                                </div>
                            </div> 
                        </div>}     
                  </div>}
                  {this.state.crew_id &&
                  <div className="box-content">
                     <div className="table-responsive">
                        <table id="data-table" className="table" style={{width:"100%"}}>
                           <thead>
                              <tr>
                                 <th></th>
                                 <th className="phone " >{LBL_SHIFT+' @ '+LBL_EVENT_TITLE}</th>
                                 <th>{LBL_LOCATION}</th>
                                 <th>{LBL_START_CHECKIN_TIME} </th>
                                 <th>{LBL_END_CHECKOUT_TIME}  </th>
                                 <th className={this.state.isClientPage ? "hide" : "text-center min-width-150"}>{lblCrewPay} ({profileCurrency})</th>
                                 <th className="text-center">{LBL_SCHEDULED_HRS} </th>
                                 {/*<th className="text-center">{LBL_ACTUAL_HRS} </th>*/}
                                 <th className="text-center">{LBL_OT_HRS} </th>
                                 <th className="text-center">{LBL_OE_DETAILS} </th>
                                 <th className="text-center">{LBL_INV_NO} </th>
                                 {isTimesheetModify &&
                                 <th className="action">&nbsp;</th>
                                 }
                              </tr>
                           </thead>
                           <tbody>
                           
                           {!timesheetShiftList || !Array.isArray(timesheetShiftList) || timesheetShiftList.length===0  && 
                                <tr>
                                    <td colSpan="13" className="text-center">{MSG_NOT_FOUND}</td>
                                </tr>
                            }
                            
                           { timesheetShiftList.map((item, index)  => {

                                 let imageClass = item.is_crew_chief?'img-fluid img-prof-small img-crew-chief':'img-fluid img-prof-small';
                                 let shift_start_time = converDateToLocal(item.shift_start_time,timeZone.utc_offset,'ddmmyyyyhhmm'); 
                                 let shift_end_time = converDateToLocal(item.shift_end_time,timeZone.utc_offset,'ddmmyyyyhhmm'); 
                                 let checkin_datetime = converDateToLocal(item.checkin_datetime,timeZone.utc_offset,'ddmmyyyyhhmm'); 
                                 let checkout_datetime = converDateToLocal(item.checkout_datetime,timeZone.utc_offset,'ddmmyyyyhhmm'); 
                                 let scheduled_hours = convertDecimalToHHMM(item.scheduled_hours);
                                 let profileImgTag = <img className={imageClass} src={require('../../'+URL_IMG+'crew-icon.jpg')} alt={item.crew_name} title={item.crew_name} />;
                                 let pay_level_name = item.pay_level_name && item.pay_level_name.length ? item.pay_level_name : ''; 
                                             let skill_name = item.skill_name && item.skill_name.length ? item.skill_name : '';
                                             const scheduleShiftStatus = SCHEDULE_CREW_STATUS.filter(x => Number(x.statusCode)===Number(item.schedule_status));
                                 const chiefIcon = item.is_crew_chief? <span><img className='cheifimg-icon' src={require('../../'+ URL_IMG +'cheif.svg')}></img></span>:'';
                                 let over_time = convertDecimalToHHMM(item.over_time); 
                                 rowNum++; 
                                 let rowNumStr = rowNum.toString()
                                 let hideEdit = false; 
                                 if(this.state.isClientPage === true){
                                    hideEdit = true;
                                 }if(item.oe_requested){
                                    hideEdit = false;
                                 }
                                 return (
                                    <React.Fragment key={index}>
                                       <tr>
                                          <td className="max-width-15 veritcal-alignment-text-top "><span className="change-count color-red text-bold marginTop10">{item.special_shift?"! ":""}</span></td>
                                          <td>
                                             <span>{chiefIcon}</span>
                                             {crew_details.vehicle_added && <span className="chief-icon background-black"><img className="car-image" src={require('../../'+URL_IMG+'car_filled.svg')} alt="Action" /></span>}
                                             <b>{item.shift_title+' @ '+item.event_title}</b>
                                             
                                             {pay_level_name && pay_level_name.length > 1 && <p className="paddingTop0 paddingBottomp0"><small>{pay_level_name}</small></p>}
                                             {skill_name && skill_name.length > 1 && <p className="mb-0 text-12">{skill_name}</p>}
                                             {<p><span className={"status "+scheduleShiftStatus[0].colorClass}><small className="status-fill">{scheduleShiftStatus[0].statusString}</small></span></p>}
                                          </td>
                                          <td>{item.shift_location[0].location.venue}</td>
                                          <td><b>{shift_start_time}</b><br></br>{checkin_datetime}</td> 
                                          <td><b>{shift_end_time}</b><br></br>{checkout_datetime}</td>
                                          <td className={this.state.isClientPage ? "hide" : "text-center"}>
                                             {showStaffPayDetails(profileCurrency,supervisor,item)}
                                          </td>

                                          <td className="text-center">{scheduled_hours}</td>

                                          {/*<td className="text-center">{convertDecimalToHHMM(item.actual_hours)}</td>*/}

                                          <td className="text-center">{over_time}
                                             {isTimesheetModify && <p><span className={item.over_time_approval_status===1? "approved" : item.over_time_approval_status===1?"rejected":item.over_time>0? "pending-underline":""} onClick={item.over_time_approval_status!==0?this.justClick:item.over_time>0?(e) => this.editBtnClick(e, item.id, item.timesheet_id, item.crew_profile_id,false,item.invoice_sent):this.justClick}></span></p>}
                                          </td>
                 
                                             <td className="text-center">
                                                
                                                      {item.expenses.map((ite, index)  => {
                                                        return(
                                                         <p key={index} className={ite.approved===1?"p-content":"p-content color-red"}>{ite.expense && <small className={ite.approved===2?"strike-through":""}>{ite.expense.name} : {profileCurrency} {ite.amount}</small>}</p>
                                                        )

                                                })}
                                                
                                             </td>

                                             <td className="text-center">{item.invoice_sent && <Link to="#" onClick={(e) => this.redirectToEvent(e,item.quote_number,item.event_id)}><b>{item.invoice_number}</b></Link>}</td>
                                             
                                             <td>
                                                <div className={item.over_time_approval_status===0 && item.over_time>0?"dropdown":hideEdit? "hide" : "dropdown"} id={'dropdown-'+rowNumStr}>
                                                   <button className="dropdown-toggle" type="button"
                                                      id={'dropdownMenuButton-'+rowNumStr} data-toggle="dropdown"
                                                      aria-haspopup="true" onClick={(e) => this.onShowActionButtons(e, rowNumStr)} >
                                                      <input type="image" id={"img-action-"+rowNumStr} src={require('../../'+URL_IMG+'action.png')} alt="Action" onBlur={(e) => this.onHideActionButtons(e, rowNumStr)} ></input>
                                                   </button>
                                                   <div className="dropdown-menu" id={'dropdown-menu-'+rowNumStr}
                                                      aria-labelledby={'dropdownMenuButton-'+rowNumStr}>
                                                         <Link className="dropdown-item edit" to="#" onMouseDown={(e) =>  this.editBtnClick(e, item.id, item.timesheet_id, item.crew_profile_id, false,item.invoice_sent)}>{LBL_EDIT}</Link> 
                                                         
                                                   </div>
                                                </div>
                                             </td>
                                          
                                       </tr>
                                    </React.Fragment>
                                 )
                              })
                           }
                           </tbody>
                        </table>
                        <Paginator totalPage={totalPage} activePage={activePage} startIndex={startIndex} endIndex={endIndex} onPagePrevious={this.onPagePrevious} onPageUp={this.onPageUp} onPageNext={this.onPageNext}/>
                        <div className="clear-b-scroll-sector">&nbsp;</div>   
                     </div>
                  </div>}

                  {!this.state.crew_id &&
                  <div className="box-content">
                     <div className="table-responsive">
                        <table id="data-table" className="table" style={{width:"100%"}}>
                           <thead>
                              <tr>
                                 <th></th>
                                 <th>{LBL_SLNUM}</th>
                                 <th></th>     
                                 {/* onClick={(e) => this.onSort(e,'user__first_name')}  className="phone sorting_asc" 
                                 onClick={(e) => this.onSort(e,'user__email')}    className="sorting_asc user-doc"                   */}
                                 <th className="phone " >{LBL_SHIFT+' @ '+LBL_EVENT_TITLE}</th>
                                 {/*<th  className="user-doc min-width-250">{lblCrew}</th>*/}
                                 <th>{LBL_LOCATION}</th>
                                 <th>{LBL_START_CHECKIN_TIME} </th>
                                 <th>{LBL_END_CHECKOUT_TIME}  </th>
                                 <th className={this.state.isClientPage ? "hide" : "text-right min-width-150"}>{lblCrewPay} ({profileCurrency})</th>
                                 <th className="text-center">{LBL_SCHEDULED_HRS} </th>
                                 {/*<th className="text-center">{LBL_ACTUAL_HRS} </th>*/}
                                 <th className="text-center">{LBL_OT_HRS} </th>
                                 <th className="text-center">{LBL_OE_DETAILS} </th>
                                 <th className="text-center">{LBL_INV_NO} </th>
                                 {isTimesheetModify &&
                                 <th className="action">&nbsp;</th>
                                 }
                              </tr>  
                           </thead>
                           <tbody>

                           {/* Shift@Event, Crew, Location, Start Time, End Time Scheduled Hrs
	Crew Name, Checkin Time, Checkout Time, Schedule Hrs, Actual Hrs, OT hrs, Approval Status */}
   
                           {/* {this.state.noRowsError!==undefined && this.state.noRowsError.length > 1  && 
                                    <tr>
                                        <td colSpan="11" className="text-center">{this.state.noRowsError}</td>
                                    </tr>
                           } */}


                           {!timesheetShiftList || !Array.isArray(timesheetShiftList) || timesheetShiftList.length===0  && 
                                <tr>
                                    <td colSpan="12" className="text-center">{MSG_NOT_FOUND}</td>
                                </tr>
                            }

                           { timesheetShiftList.map((item, index)  => {
                              let indeNum = (PAGENUMROWS_AFFILIATE*(activePage-1))+index+1; 
                              let shift_start_time = converDateToLocal(item.shift_start_time,timeZone.utc_offset,'ddmmyyyyhhmm'); 
                              let shift_end_time = converDateToLocal(item.shift_end_time,timeZone.utc_offset,'ddmmyyyyhhmm'); 
                              let scheduled_hours = convertDecimalToHHMM(item.scheduled_hours);
                              let total_staff_pay = parseFloat(item.total_staff_pay).toFixed(2);

                              // let total_over_time_hours = convertDecimalToHHMM(item.total_over_time_hours); 
                                    return (
                                       <React.Fragment key={index}>
                                          <tr className={item.isExpand?'shown':''}  >
                                             <td className="details-control sorting_1" onClick={(e) => this.onShowHideDetails(e, item.id)}></td>
                                             <td>{indeNum}</td>
                                             <td className="max-width-15"><span className="change-count color-red text-bold marginTop10">{item.special_shift?"! ":""}</span></td>
                                             <td>{item.shift_title+' @ '+item.event_title}</td>
                                             {/*<td>&nbsp;</td>*/}
                                             <td>{item.shift_location[0].location.venue}</td>
                                             <td>{shift_start_time}</td> 
                                             <td>{shift_end_time}</td>
                                             <td className={this.state.isClientPage ? "hide" : "text-right"}>{profileCurrency} {total_staff_pay}</td>
                                             <td className="text-center">{scheduled_hours}</td>
                                             <td className="text-center"><p className="m-0">
                                                {/* {this.convertMinsToHrsMins(item.total_actual_hours)} */}
                                             </p></td>

                                             <td className="text-center">
                                                {/* {total_over_time_hours} */}
                                             </td>
                                             <td className="text-center">{item.invoice_sent && <Link to="#" onClick={(e) => this.redirectToEvent(e,item.quote_number,item.event_id)}><b>{item.invoice_number}</b></Link>}</td>
                                                
                                             {isTimesheetModify &&   
                                                <td>                                               
                                               </td>
                                            }
                                        </tr>    
                                       {  item.isExpand && 
                                          item.hasOwnProperty('crew_details') && item.crew_details.length>0?
                                          item.crew_details.map((crew_details, index2)  => {
                                             let hideEdit = false; 
                                             if(this.state.isClientPage === true){
                                                hideEdit = true;
                                             }if(crew_details.oe_requested){
                                                hideEdit = false;
                                             }
                                             rowNum++; 
                                             let rowNumStr = rowNum.toString()
                                             let checkin_datetime  = converDateToLocal(crew_details.checkin_datetime,timeZone.utc_offset,'ddmmyyyyhhmm');      
                                             let checkout_datetime  = converDateToLocal(crew_details.checkout_datetime,timeZone.utc_offset,'ddmmyyyyhhmm');      
                                             let scheduled_hours = convertDecimalToHHMM(crew_details.scheduled_hours); 
                                             let over_time = convertDecimalToHHMM(crew_details.over_time); 

                                             let imageClass = crew_details.is_crew_chief?'img-fluid img-prof-small img-crew-chief':'img-fluid img-prof-small';

                                             let profileImgTag = <img className={imageClass} src={require('../../'+URL_IMG+'crew-icon.jpg')} alt={crew_details.crew_name} title={crew_details.crew_name} />;
                                             
                                             if ((crew_details.crew_profile_image) && crew_details.crew_profile_image.trim().length > 0){
                                                 profileImgTag = <img className={imageClass} src={crew_details.crew_profile_image} alt={crew_details.crew_name} title={crew_details.crew_name} />;
                                             }else if(((!crew_details.crew_profile_image) || crew_details.crew_profile_image.trim().length===0) && crew_details.avatar_name && crew_details.avatar_name.trim().length > 0){
                                               let pcolor = crew_details.profile_color ? crew_details.profile_color : AVATAR_BG_COLOR; 
                                             profileImgTag = <div title={crew_details.crew_name} className={crew_details.is_crew_chief?'center-align img-fluid img-prof-small img-avatar img-crew-chief':'center-align img-fluid img-prof-small img-avatar'} style={{ background:pcolor,borderColor:pcolor}}>{crew_details.avatar_name}</div>; 
                                             }
                                             const chiefIcon = crew_details.is_crew_chief? <span><img className='cheifimg-icon' src={require('../../'+ URL_IMG +'cheif.svg')}></img></span>:'';
                                          
                                             // className={(actionNeeded && (crew_details.over_time_approval_status && Number(crew_details.over_time) > 0))?'hide':''} 
                                             let pay_level_name = crew_details.pay_level_name && crew_details.pay_level_name.length ? crew_details.pay_level_name : ''; 
                                             let skill_name = crew_details.skill_name && crew_details.skill_name.length ? crew_details.skill_name : '';
                                             let skill_icon = crew_details.skill_icon && crew_details.skill_icon.length ? crew_details.skill_icon : '';
                                             const scheduleShiftStatus = SCHEDULE_CREW_STATUS.filter(x => Number(x.statusCode)===Number(crew_details.schedule_status));
                                           return(
                                             <tr key={index+index2} >
                                             <td>&nbsp;</td>
                                             <td>&nbsp;</td>
                                             <td>&nbsp;</td>
                                             <td>
                                                <div className="crew">
                                                   <div className="crew__aside">
                                                      <div className="crew__thumb skill-tooltip" onClick={(e) => this.showCrewTimesheets(crew_details.crew_profile_id)}>
                                                         {profileImgTag}
                                                      </div>
                                                   </div> 
                                                   <div className="crew__content content-feedback">
                                                   <div className="displayItemFlex"><span>{chiefIcon}{crew_details.vehicle_added && <span className="chief-icon background-black"><img className="car-image" src={require('../../'+URL_IMG+'car_filled.svg')} alt="Action" /></span>}</span>
                                                   {/* <Link to="#" onClick={(e) => this.showCrewTimesheets(crew_details.crew_profile_id)}> */}
                                                   <b style={{color:"#003B5C"}}>{crew_details.crew_name}</b>
                                                   {/* </Link> */}
                                                   </div>
                                                   {pay_level_name && pay_level_name.length > 1 && <p className="paddingTop0 paddingBottomp0"><small>{pay_level_name}</small></p>}
                                                   {skill_name && skill_name.length > 1 && 
                                                   <p className="mb-0 text-12">{skill_icon.length > 0 && <i className={"fas "+skill_icon}></i> } {skill_name}</p>}
                                                   {<p><span className={"status "+scheduleShiftStatus[0].colorClass}><small className="status-fill">{scheduleShiftStatus[0].statusString}</small></span></p>}
                                                   </div>
                                                </div>    
                                             </td>

                                             <td>&nbsp;</td>

                                             <td><p className="m-0">{checkin_datetime}</p></td>

                                             <td><p className="m-0">{checkout_datetime}{item.cron_created?' ('+LBL_AUTO+')':''}</p></td>
                                             <td className={this.state.isClientPage ? "hide" : "text-right"}>
                                                {showStaffPayDetails(profileCurrency,supervisor,crew_details)}   
                                             </td> 

                                             <td className="text-center">{scheduled_hours}</td>

                                             {/*<td className="text-center">{convertDecimalToHHMM(crew_details.actual_hours)}</td>*/}

                                             <td className="text-center">
                                                <p></p>
                                                {over_time}
                                                {isTimesheetModify &&<p><span className={crew_details.over_time_approval_status===1? "approved" :crew_details.over_time_approval_status===2?"rejected":crew_details.over_time>0? "pending-underline":""} onClick={crew_details.over_time_approval_status!==0? this.justClick:crew_details.over_time>0?(e) => this.editBtnClick(e, item.id, crew_details.timesheet_id, crew_details.crew_profile_id, false,crew_details.invoice_sent) : this.justClick}></span></p>}
                                             </td>
                                             
                                             <td className="text-right">
                                                {crew_details.expenses.map((ite, index)  => {

                                                        return(
                                                         <p key={index} className={ite.approved===1?"p-content":"p-content color-red"}>{ite.expense && <small className={ite.approved===2?"strike-through":""}>{ite.expense.name} : {profileCurrency} {ite.amount}</small>}</p>
                                                        )

                                                })}
                                             </td>
                                             
                                             <td className="text-center"></td>
                                             {isTimesheetModify &&
                                             <td>
                                                <div className={crew_details.over_time_approval_status===0 && crew_details.over_time>0?"dropdown":hideEdit? "hide" : "dropdown"} id={'dropdown-'+rowNumStr}>
                                                   <button className="dropdown-toggle" type="button"
                                                      id={'dropdownMenuButton-'+rowNumStr} data-toggle="dropdown"
                                                      aria-haspopup="true" onClick={(e) => this.onShowActionButtons(e, rowNumStr)} >
                                                      <input type="image" id={"img-action-"+rowNumStr} src={require('../../'+URL_IMG+'action.png')} alt="Action" onBlur={(e) => this.onHideActionButtons(e, rowNumStr)} ></input>
                                                   </button>
                                                   <div className="dropdown-menu" id={'dropdown-menu-'+rowNumStr}
                                                      aria-labelledby={'dropdownMenuButton-'+rowNumStr}>
                                                         <Link className="dropdown-item edit" to="#" onMouseDown={(e) => this.editBtnClick(e, item.id, crew_details.timesheet_id, crew_details.crew_profile_id, false, crew_details.invoice_sent)}>{LBL_EDIT}</Link> 
                                                         
                                                   </div>
                                                </div>
                                             </td>
                                          }

                                          </tr>     
                                           )
                                          }):<tr className="hide"></tr>
                                       }
                                       </React.Fragment>
                                     )
                                  })      
                                }                      
                           </tbody>
                        </table>
                        <Paginator totalPage={totalPage} activePage={activePage} startIndex={startIndex} endIndex={endIndex} onPagePrevious={this.onPagePrevious} onPageUp={this.onPageUp} onPageNext={this.onPageNext}/>
                        <div className="clear-b-scroll-sector">&nbsp;</div>   
                     </div>
                  </div>}
               </div>

               <ModalWindow ref={this.modal} setSelectCrewProfileId={this.setSelectCrewProfileId} selectCrewProfileId={this.state.selectCrewProfileId} header={LBL_EDIT_TIMESHEET} saveFormData={ (e)=>this.openConfirmModal(selectedTimesheetId)} resetModalForm={this.onModalFormReset} type={'save'} extra_field={''} onApproveOtChange ={this.onChangeApproveOT} approveChecked={approvedEventStatus} mark_absent={timesheetData.markAbsentStatus && !this.state.isClientPage ? 'markAbsent' : ''} onMarkAbsentChange={this.onMarkAbsentChange} markAbsentChecked={this.state.markAbsentChecked} enableApprove={false} viewHeading={this.state.viewHeading}>                  
                  <div className="row">
                     <div className="col-md-6">
                           <div className="form-group">
                              <label>{LBL_EVENT}</label>
                              <div className="text-input text-optional"><input name="event" type="text" placeholder="" value={timesheetData.event} disabled /></div>                              
                           </div>
                     </div> 
                     <div className="col-md-6">
                           <div className="form-group">
                              <label>{LBL_SHIFT_AND_SKILL}</label>
                              <div className="text-input text-optional"><input name="shift" type="text" placeholder="" value={timesheetData.shift} disabled /></div>                              
                           </div>
                     </div>
                  </div>  
                  <div className="row">
                     <div className="col-md-6">
                           <div className="form-group">
                              <label>{LBL_PERSON}</label>
                              <div className="text-input text-optional"><input name="person" type="text" placeholder="" value={timesheetData.person} disabled /></div>                              
                           </div>
                     </div>  
                     <div className="col-md-6">
                           <div className="form-group">
                              <label>{LBL_LOCATION}</label>
                              <div className="text-input text-optional"><input name="location" type="text" placeholder="" value={timesheetData.location} disabled /></div>                             
                           </div>
                     </div>
                  </div>    

                  <div className="row">
                     <div className="col-md-6">                  
                           <div className="form-group">
                                 <label>{LBL_CHECKIN_DATE_TIME}</label>
                                 <div className="row">
                                    <div className="col-md-6">
                                        <div className="calendar-input">
                                            <DatePicker 
                                                selected={selectedStartDate}
                                                onChange={selected =>this.onStartDateChange(selected)}
                                                name="startDate"
                                                showMonthDropdown
                                                showYearDropdown
                                                dropdownMode="select"
                                                dateFormat="dd/MM/yyyy"
                                                placeholderText="Select"
                                                // minDate={selectedStartDate}
                                                fixedHeight
                                                disabled={this.state.isClientPage}     
                                            />
                                        </div>
                                    </div>
                                    <div className="col-md-6">
                                        <div className="time-input">
                                            <Datetime viewMode='time' dateFormat={false} timeFormat={'HH:mm'} inputProps={{ placeholder: 'Select', name:'startTime', className:formErrors.startTime.length >0 ? "input-error" : '',disabled:this.state.isClientPage}}  value={  timesheetData.startTime} onChange={selected=>this.onHandleChangeStartTime(selected)} onBlur={selected=>this.onBlurStartTime(selected)} disabled={this.state.isClientPage} />
                                        </div>
                                    </div>
                                </div>
                                
                            </div>
                     </div>
                     <div className="col-md-6">                    
                           <div className="form-group">
                                <label>{LBL_CHECKOUT_DATE_TIME}</label>
                                <div className="row">
                                    <div className="col-md-6">
                                        <div className="calendar-input">
                                            <DatePicker 
                                                selected={selectedEndDate}
                                                onChange={selected =>this.onEndDateChange(selected)}
                                                name="endDate"
                                                showMonthDropdown
                                                showYearDropdown
                                                dropdownMode="select"
                                                dateFormat="dd/MM/yyyy"
                                                placeholderText="End Date"
                                                minDate={selectedStartDate} 
                                                fixedHeight  
                                                disabled={this.state.isClientPage} 
                                            />
                                        </div>
                                    </div>
                                    <div className="col-md-6">
                                        <div className="time-input"> 
                                            <Datetime viewMode='time' dateFormat={false} timeFormat={'HH:mm'} inputProps={{ placeholder: 'Select', name:'endTime', className:formErrors.endTime.length >0 ? "input-error" : '',disabled:this.state.isClientPage}}  value={  timesheetData.endTime} onChange={selected=>this.onHandleChangeEndTime(selected)}  onBlur={selected=>this.onBlurEndTime(selected)}  />
                                        </div>
                                    </div>
                                </div>
                            </div>
                     </div> 
                  </div>   
                  
                  <div className="row">
                     <div className="col-md-6">
                           <div className="form-group">
                              <label>{LBL_SHIFT_LENGTH_HOURS}</label>
                              <div className="text-input text-optional"><input name="shiftLength" type="text" placeholder="" value={timesheetData.shiftLength} disabled /></div>                             
                           </div>
                     </div>           
    

                  </div>      
                  <div className="row">
                     <div className="col-md-12">
                        {formErrors.totalHours.length >0 && (
                           <div className="text-red left-align text-12">{formErrors.totalHours}</div>
                        )} 
                     </div>  
                  </div>
                  <div className={this.state.isClientPage ? "row hide" : "row"}>
                  {/* Normal crew pay details */}
                     <div className="col-md-3">
                           <div className="form-group">
                              <label>{LBL_PAY_RATE_PER_HOUR}</label>
                              <div className="text-input"><input className={this.state.formErrors.pay_rate.length >0 ? "input-error" : ''} name="pay_rate" type="text" placeholder="" value={timesheetData.pay_rate} onChange={this.onHandleChange} /></div>                              
                           </div>
                     </div>
                     <div className="col-md-3">
                           <div className="form-group">
                              <label> {LBL_PAY_RATE_TOTAL} ({profileCurrency})</label>
                              <div className="text-input text-optional"><input name="pay_total" type="text" placeholder="" value={timesheetData.pay_total } disabled /></div>                              
                           </div>
                     </div>

                     <div className="col-md-3">
                           <div className="form-group">
                              <label>{LBL_CHARGE_RATE_PER_HOUR}</label>
                              <div className="text-input"><input className={this.state.formErrors.charge_rate.length >0 ? "input-error" : ''} name="charge_rate" type="text" placeholder="" value={timesheetData.charge_rate} onChange={this.onHandleChange} /></div>                              
                           </div>
                     </div>
                     
                     <div className="col-md-3">
                           <div className="form-group">
                              <label> {LBL_CHARGE_RATE_TOTAL} ({profileCurrency})</label>
                              <div className="text-input text-optional"><input name="charge_total" type="text" placeholder="" value={timesheetData.charge_total } disabled /></div>                              
                           </div>
                     </div>
                  </div> 

                  <div className={(this.state.isClientPage || !timesheetData?.total_travel_cost) ? "row hide" : "row"} >  
                     <div className="col-md-6">
                           <div className="form-group">
                              <label>{LBL_SHIFT_TOTAL_TRAVEL_COST}</label>
                              <div className="text-input text-optional"><input name="total_travel_cost" type="text" placeholder="" value={timesheetData.total_travel_cost} disabled /></div>                      
                           </div>
                     </div>  
                     <div className="col-md-3">
                           <div className="form-group">
                              <label>{LBL_DRIVER_PAY_RATE}</label>
                              <div className="text-input"><input className={((timesheetData?.total_travel_cost < (timesheetData.driver_pay_rate+timesheetData.passenger_pay_rate)) || (this.state.formErrors.driver_pay_rate.length > 0)) ? "input-error" : ''} name="driver_pay_rate" type="text" placeholder="" value={timesheetData.driver_pay_rate} onChange={this.onHandleChange} /></div>                      
                           </div>
                     </div>  
                     <div className="col-md-3">
                           <div className="form-group">
                              <label>{LBL_PASSENGER_PAY_RATE}</label>
                              <div className="text-input"><input className={((timesheetData?.total_travel_cost < (timesheetData.driver_pay_rate+timesheetData.passenger_pay_rate)) || (this.state.formErrors.passenger_pay_rate.length > 0)) ? "input-error" : ''} name="passenger_pay_rate" type="text" placeholder="" value={timesheetData.passenger_pay_rate} onChange={this.onHandleChange} /></div>                             
                           </div>
                     </div> 
                       
                  </div>  

                  <div className={"row padding-left-15 margin-top-10"}> 
                  <Accordion className="width-100-percent">
                     <Accordion.Toggle as={Nav} variant="link" eventKey="0" className={this.state.showOverTimeData!==true?' head-collp collapsed bgLightGreyed textPointer':' head-collp textPointer'} onClick={(e)=>this.accordionChange(e,'overtime')}>
                        <label>{LBL_OVER_TIME_HOURS}</label>
                     </Accordion.Toggle>
                     
                     <Accordion.Collapse eventKey="0">
                        <>
                        <div className="row"> 
                           <div className="col-md-6">
                              <div className="form-group">
                                 {/* <label>{' + '+LBL_OVER_TIME_HOURS} </label> */}
                                 {/* <div className="text-input"><input className={this.state.formErrors.overTimeHours.length >0 ? "input-error" : ''} name="overTimeHours" type="text" placeholder="" value={timesheetData.overTimeHours} onChange={this.onHandleChange} /></div>    */}
                                 <div className={'time-input'}>
                                 <Datetime viewMode='time' dateFormat={false} timeFormat={'HH:mm'} inputProps={{ placeholder: LBL_SELECT, name:'overTimeHours', className:formErrors.overTimeHours.length >0 ? "input-error" : ''}}  value={timesheetData.overTimeHours === '' ? selectedoverTimeHours : timesheetData.overTimeHours} onChange={selected=>this.onHandleChangeoverTimeHours(selected)} timeConstraints={ ENUM_SHIFT_LENGTH_HHMM }/> 
                                 </div>   
                                 {this.state.otLengthError.length > 1 && <div className="text-red"><small>{this.state.otLengthError}</small></div>}                         
                              </div>
                           </div>
                           <div className="col-md-6">
                              {this.state.enableApprove && <div className="checkbox-wrapper">
                                  <div className="custom-radio">
                                      <input type="radio" id="radio1" name="radio" checked={approvedEventStatus===1?"checked":""} onChange={(e) => this.onChangeApproveOT(e,1)} />
                                      <label className="radio" htmlFor="radio1"></label>
                                      <label className="labeltext approve-color" htmlFor="radio1">{LBL_APPROVE}</label>
                                  </div>
                                  <div className="custom-radio">
                                      <input type="radio" id="radio2" name="radio" checked={approvedEventStatus===2?"checked":""} onChange={(e) => this.onChangeApproveOT(e,2)} />
                                      <label className="radio" htmlFor="radio2"></label>
                                      <label className="labeltext reject-color" htmlFor="radio2">{ LBL_REJECT}</label>
                                  </div>
                              </div>}
                           </div>
                        </div>
                        {!this.state.isClientPage && <div className="row margin-right-12"> 
                           <div className="col-md-3">
                              <div className="form-group">
                                 <label>{LBL_OT_PAY_RATE_PER_HOUR}</label>
                                 <div className="text-input"><input className={this.state.formErrors.over_time_pay_rate.length >0 ? "input-error" : ''} name="over_time_pay_rate" type="text" placeholder="" value={timesheetData.over_time_pay_rate} onChange={this.onHandleChange} /></div>                              
                              </div>
                           </div>
                        
                            <div className="col-md-3">
                                 <div className="form-group">
                                    <label> {LBL_OT_PAY_RATE_TOTAL} ({profileCurrency})</label>
                                    <div className="text-input text-optional"><input name="over_time_pay_total" type="text" placeholder="" value={timesheetData.over_time_pay_total } disabled /></div>                              
                                 </div>
                              </div> 
                           
                           <div className="col-md-3">
                                 <div className="form-group">
                                    <label>{LBL_OT_CHARGE_RATE_PER_HOUR}</label>
                                    <div className="text-input"><input className={this.state.formErrors.over_time_charge_rate.length >0 ? "input-error" : ''} name="over_time_charge_rate" type="text" placeholder="" value={timesheetData.over_time_charge_rate} onChange={this.onHandleChange} /></div>                              
                                 </div>
                              </div>
                           
                           <div className="col-md-3">
                              <div className="form-group timesheet-width">
                                 <label> {LBL_OT_CHARGE_RATE_TOTAL} ({profileCurrency})</label>
                                 <div className="text-input text-optional"><input name="over_time_charge_total" type="text" placeholder="" value={timesheetData.over_time_charge_total } disabled /></div>                              
                              </div>
                           </div>
                        
                        </div>}
                        </>
                     </Accordion.Collapse>
                  </Accordion>   
                  </div>


                  <div className={"row padding-left-15  margin-top-10"}> 
                  <Accordion className="width-100-percent">
                     <Accordion.Toggle as={Nav} variant="link" eventKey="0" className={this.state.showOtherExpenseData!==true?'head-collp collapsed bgLightGreyed textPointer':'head-collp textPointer'} onClick={(e)=>this.accordionChange(e,'otherexpense')}> 
                        <label>{LBL_OTHER_EXPENSES}</label>
                     </Accordion.Toggle>
                     
                     <Accordion.Collapse eventKey="0">
                        <>
                        {/*<div className="row">
                           <div className="col-md-12">
                              <div className="form-group min-width-460">
                                 <div className="form-group multisel_textbox min-width-460">
                                    <div className='form-group select-input skills'>
                                       <CustomMultiSelect data={otherExpMultiListStaff}  onChange={selected =>this.onOtherExpDataChange(selected)} isFloat={true} isTextBox={true} isInputDescr={true} classValue={formErrors.otherExpCost.length >0 ? "input-error" : ''} />
                                    </div>
                                 </div> 
                              </div>
                           </div>  
                        </div>*/}

                        <div className="box-content">
                           <div className="table-responsive">
                              <table id="data-table" className="table" style={{width:"100%"}}>
                                  <thead>
                                      <tr>
                                          <th className="text-center">{LBL_SELECT}</th>
                                          <th className="text-center">{LBL_OTHER_EXPENSES}</th>
                                          <th className="text-center max-width-150">{LBL_AMOUNT}</th>
                                          <th className="text-center">{LBL_DESCRIPTION}</th>
                                          <th className="text-center">{LBL_FILE}</th>
                                          <th className="text-center min-width-200"></th>
                                      </tr>
                                  </thead>                                    
                                  <tbody> 
                                      {Array.isArray(otherExpMultiListStaff) && otherExpMultiListStaff.length===0 && <tr><td className="text-center" colSpan="6">{MSG_NOT_FOUND}</td></tr>}
                                      
                                      { Array.isArray(otherExpMultiListStaff) && otherExpMultiListStaff.map((item,index)  => {
                                             
                                      return (
                                          <tr key={index}>
                                              <td className="text-center">
                                                  <div className="custom-checkbox padding-right-0"><input type="checkbox" id={"select_"+item.value} name={"select_"+item.value} onChange={e => this.otherExpenseChange(e,index,item.value,0)} checked={this.state.otherExpenseData[item.value]?this.state.otherExpenseData[item.value].select:false} />
                                                      <label className="checkbox" htmlFor={"select_"+item.value} ></label>
                                                   </div>
                                             </td>
                                              <td className="text-left">
                                                   <label>{item.label}</label>
                                              </td>
                                              <td className="text-center max-width-150">
                                                <div className="text-input"><input className={'grid-input '+ (formErrors.otherExpenseData[item.value] !== undefined ?  (formErrors.otherExpenseData[item.value] ? "input-error" : '') : '')} name={"amount_"+item.value} type="text" placeholder="" value={this.state.otherExpenseData[item.value]?this.state.otherExpenseData[item.value].amount:''} onChange={e=>this.otherExpenseChange(e,index,item.value,0)} disabled={this.state.otherExpenseData[item.value]?false:true}/></div>                              
                                              </td>
                                              <td className="text-center">
                                                <div className="text-input"><input className={'grid-input width-100'} name={"desc_"+item.value} type="text" placeholder="" value={this.state.otherExpenseData[item.value]?this.state.otherExpenseData[item.value].desc:''} onChange={e=>this.otherExpenseChange(e,index,item.value,0)} disabled={this.state.otherExpenseData[item.value]?false:true}/></div>                              
                                              </td>
                                              <td className="text-center min-width-150">
                                                  {item.reciepts && 
                                                  item.reciepts.map(el => {
                                                      let ext = el.file.substr(el.file.lastIndexOf('.') + 1);
                                                     
                                                      return (
                                                      <div className="file-icon" key={el.id}>
                                                          <a href={el.file} target="_blank" rel="noopener noreferrer" style={{display:"inline"}}>
                                                          <FileIcon extension={ext} fold={true} 
                                                          radius={3} color="whitesmoke" {...defaultStyles[ext]}/>
                                                          </a>
                                                          {/*<span className=" remove-file" onClick=
                                                          {(e)=>this.removeDocFile(el.id,item.id,item.crew_skill_details===null?item.affiliate_document_details.name:item.crew_skill_details.affiliate_skill.certificate_name)}><i className="las la-minus"></i></span>*/}
                                                      </div>
                                                      )
                                                  })
                                                  }

                                              </td>
                                              <td className="text-center min-width-150">
                                                {/*<div className="custom-checkbox padding-right-0"><input type="checkbox" id={"approve_"+item.value} name={"approve_"+item.value} onChange={selected=>this.otherExpenseChange(selected,index,item.value)} checked={this.state.otherExpenseData[item.value]?this.state.otherExpenseData[item.value].approve:false} disabled={this.state.otherExpenseData[item.value]?false:true}/>
                                                      <label className="checkbox" htmlFor={"approve_"+item.value} ></label>
                                                   </div>*/}
                                                <div className="checkbox-wrapper">
                                                    <div className="custom-radio">
                                                        <input type="radio" id={"approve_"+item.value+"1"} name={"approve_"+item.value+"1"} checked={!this.state.otherExpenseData[item.value]?'':this.state.otherExpenseData[item.value].approve===1?"checked":""} onChange={selected=>this.otherExpenseChange(selected,index,item.value,1)} disabled={this.state.otherExpenseData[item.value]?false:true} />
                                                        <label className="radio" htmlFor={"approve_"+item.value+"1"}></label>
                                                        <label className="labeltext approve-color" htmlFor={"approve_"+item.value+"1"}>{LBL_APPROVE} </label>
                                                    </div>
                                                    <div className="custom-radio">
                                                        <input type="radio" id={"approve_"+item.value+"2"} name={"approve_"+item.value+"2"} checked={!this.state.otherExpenseData[item.value]?'':this.state.otherExpenseData[item.value].approve===2?"checked":""} onChange={selected=>this.otherExpenseChange(selected,index,item.value,2)} disabled={this.state.otherExpenseData[item.value]?false:true}/>
                                                        <label className="radio" htmlFor={"approve_"+item.value+"2"}></label>
                                                        <label className="labeltext reject-color" htmlFor={"approve_"+item.value+"2"}>{ LBL_REJECT}</label>
                                                    </div>
                                                </div>
                                              </td>
                                              
                                          </tr>    
                                          
                                      )
                                      })      

                                      }                      
                                    </tbody>
                                 </table>
                           </div>                            
                        </div> 

                        </>
                     </Accordion.Collapse>
                  </Accordion>   
                  </div>


                  {this.state.showOverTimeData!==true && <div className="row">&nbsp;</div>}

                  {/* <div className={timesheetData.markAbsentStatus && !this.state.isClientPage?"custom-checkbox":"hide"} ><input type="checkbox" id="markAbsent" name="markAbsent" onChange={this.onMarkAbsentChange} checked={this.state.markAbsentChecked}/><label className="checkbox" htmlFor="markAbsent"></label><label className="labeltext" htmlFor="markAbsent">{LBL_MARK_ABSENT}</label></div> */}
                  
               </ModalWindow>
               <ModalWindow ref={this.modalMarkAbsent} header="Confirm Mark Absent" type="confirm" deleteConfirmedItem={this.onMarkAbsent} resetModalForm={this.onModalAbsentReset} >
                  Are you sure you want to mark this crew as absent? This action cannot be undone.
               </ModalWindow>
            </div>
            <Filter isDetail={true}  onResetFiltersButton={this.onResetFiltersButton} onApplyFilterButton={this.onApplyFilterButton}> 
               <FilterTimesheet selectedStartDate={this.state.selectedStartDate} selectedEndDate={this.state.selectedEndDate} setSelectedDate={this.setSelectedDate} actionNeeded={this.state.actionNeeded} defaultStartDate={this.state.defaultStartDate} defaultEndDate={this.state.defaultEndDate} filterClicked={this.state.filterClicked} resetFilterClicked={this.state.resetFilterClicked} applyFilterClicked={this.state.applyFilterClicked} applyFilters={this.applyFilters} isClientPage={this.state.isClientPage} clientId={this.state.clientId} onShowFilterBy={this.onShowFilterBy} />

               <div>&nbsp;</div>

            </Filter>
         </React.Fragment>
        )
    }

}
const mapStateToProps = (state) => {
      return {
        timesheet : state.timesheet.timesheet,     
        timesheetDetails:state.timesheet.timesheetDetails,   
        totalPage:state.timesheet.timesheetTotalPage,
        status:state.timesheet.status,
        activity:state.timesheet.activity,
        numRows:state.timesheet.timesheetNumRows,
        count:state.timesheet.timesheetCount,
        timesheetCSV:state.timesheet.timesheetCSV,
        errorData:state.timesheet.errorData,
        isFilterOn: state.commons.isFilterOn,
        otherExps : state.event.otherExps, 
        subactivity : state.event.subactivity,
        getActionNeeded:state.timesheet.getActionNeeded,
        serverTimeList : state.serverTimeList.serverTimeList,
        serverTimeListActivity : state.serverTimeList.serverTimeListActivity,
      }
};

const mapDispatchToProps = (dispatch) => {
    return bindActionCreators({
        timesheetShiftListAction:timesheetShiftListAction,
        timesheetDetailsAction:timesheetDetailsAction,
        timesheetUpdateAction:timesheetUpdateAction,
        timesheetCSVDownloadAction:timesheetCSVDownloadAction,
        otherExpListAction:otherExpListAction,
        setActionNeeded:setActionNeeded,
        serverTimeAction:serverTimeAction,
        timeSheetDateHeader:timeSheetDateHeader
    },dispatch);
}
export default connect(mapStateToProps,mapDispatchToProps)(Timesheet);